(function () {
  'use strict';
  
  angular
    .module('pixerf', [
      'ui.router',
      'ngRoute',
      'ngAnimate',
      'ui.bootstrap',
      'toastr',
      'ngResource',
      'loadingButton',
      'LocalStorageModule',
      'ngSanitize',
      'hm.readmore'
    ]);

})();

(function() {
    'use strict';
    angular
        .module('pixerf')
        .constant('messageConst', {
           "error" : {
                "SOME_THING_WRONG": "Oops! Looks like something went wrong. Please try again!",
                "VOTES_EXCEEDED": "You can only vote for a maximum of three photos!"
           },
           "success": {
                "RSVP": "Thanks for your RSVP!",
                "SUBMISSION": "Thanks for your submission!",
           },
           "info": {
                "SUBMISSION_CLOSED": "Submissions are now closed!"
           }
        });
})();
/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('winnersListSvc', winnersListSvc);

    winnersListSvc.$inject = ['pixerfApiMediaSvc', '$q'];

    function winnersListSvc(pixerfApiMediaSvc, $q){
      function getPrize(index){
        if(index === 0){
            return "MAGENTA AWARD<br/><span class=\"prize-subtitle\">(Winner)</span>"
        } 
        return index === 1 ? "CYAN AWARD<br/><span class=\"prize-subtitle\">(First Runner-up)</span>" : "BLEU AWARD<br/><span class=\"prize-subtitle\">(Second Runner-up)</span>";
    }
      function getWinners(){
        var def = $q.defer();
        pixerfApiMediaSvc.winners().$promise.then(function(response){
          for(var i = 0; i < response.data.data.length; i ++){
            response.data.data[i].prize = getPrize(i);
          }
          def.resolve(response.data.data);

        }, function(){
            def.reject();
        });
        return def.promise;

    }
		return {
      getWinners: getWinners
		};
    }
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('winnersListCtrl', winnersListCtrl);

    winnersListCtrl.$inject = ['$scope', 'winnersListSvc', '$rootScope', 'fileUtils', 'pixerfApiMediaSvc', 'photoDetailPopupSvc', 'arrayUtils', 'socketSvc', '$q'];

    function winnersListCtrl($scope, winnersListSvc, $rootScope, fileUtils, pixerfApiMediaSvc, photoDetailPopupSvc, arrayUtils, socketSvc, $q) {

        var self = this;

        self.onPhotoClicked = onPhotoClicked;
        self.onPhotoNavigated = onPhotoNavigated;
        self.photos = $rootScope.message.winners;
        // init();
        // function init(){
        //     if(!$rootScope.message.winners.data || ($rootScope.message.winners.data && $rootScope.message.winners.data.length === 0)){
        //         getWinners().then(function(winners){
        //             if(!$rootScope.message.winners.data || ($rootScope.message.winners.data && $rootScope.message.winners.data.length === 0)){
        //                 $rootScope.message.winners.data = winners;
        //                 $rootScope.message.votable.data = !$rootScope.message.winners.data || ($rootScope.message.winners.data && $rootScope.message.winners.data.length === 0);
        //                 $rootScope.message.published.data = !$rootScope.message.winners.data || ($rootScope.message.winners.data && $rootScope.message.winners.data.length === 0);
        //             }
        //         });
        //     }
            
        // }
        // function getWinners(){
        //     var def = $q.defer();
        //     pixerfApiMediaSvc.winners().$promise.then(function(response){
        //         def.resolve(response.data.data);
        //     }, function(){
        //         def.reject();
        //     });
        //     return def.promise;

        // }
        function onPhotoClicked(photo){
            for(var i = 0; i < self.photos.data.length; i ++){
                var photoItem = self.photos.data[i];
                photoItem.w = 1024;
                photoItem.h = 1024/photoItem.ar;
                photoItem.src = photoItem.url;
            }
            var index = arrayUtils.indexOf(self.photos.data, function(item){
                return item.id === photo.id;
            });
            var selectedPhoto = fileUtils.findFileById(self.photos.data, photo.id);
            photoDetailPopupSvc.showPopup({
                photos: self.photos.data,
                index: index,
                selectedPhoto: selectedPhoto,
                photoSwipeOptions: {isDisableVote: true}
            });
        }
        function onPhotoNavigated(index){
            // self.owlInstance.trigger('to.owl.carousel', index);
            $('.winners-list.owl-carousel').on('to.owl.carousel, next.owl.carousel, prev.owl.carousel, destroy.owl.carousel', function(e) { e.stopPropagation(); });
            $('.winners-list.owl-carousel').trigger('to.owl.carousel', index);

        }
      
    }
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .directive('winnersList', winnersList);
        winnersList.$inject = ['$compile', 'systemUtils', '$rootScope'];

    function winnersList($compile, systemUtils, $rootScope) {

        var directive = {
            scope: {
              
            },
            restrict: 'E',
            templateUrl: 'app/components/winners-list/winners-list.html',
            controller: 'winnersListCtrl',
            controllerAs: 'vm',
            replace: true,
            link: function (scope, elmt, attrs, ctrl, transcludeFn) {
                console.log(elmt);
                $rootScope.$watch("message.winners.data",  function(newValue, oldValue){
                    if(newValue && newValue.length > 0){
                        console.log(newValue);
                        setTimeout(function(){
                            // ctrl.owlInstance =  $(elmt).owlCarousel({
                            //     center: true,
                            //     items:1,
                            //     startPosition: 1,
                            //     loop: false,
                            //     dots: false,
                            //     nav: false,
                            //     navText: ["<div class='icon-arrow_left'></div>","<div class='icon-arrow_right'></div>"],
                            //     responsive:{
                            //         320:{
                            //             items:1,
                            //             nav: true,
                            //             navText: ["<div class='icon-arrow_left'></div>","<div class='icon-arrow_right'></div>"]
                            //         },
                            //         1024:{
                            //             items:2,
                            //             nav: false,
                            //         }
                            //     }
                            // });
                            // $(elmt).on('to.owl.carousel, next.owl.carousel, prev.owl.carousel, destroy.owl.carousel', function(e) { e.stopPropagation(); });
                            ctrl.owlInstance =  $(elmt).slick({
                                centerMode: true,
                                centerPadding: 0,
                                slidesToShow: 1,
                                initialSlide: 1,
                                variableWidth: true,
                                focusOnSelect: true,
                                infinite: false,
                                cssEase: 'ease-in-out',
                                prevArrow: "<div class='nav-left icon-arrow_left'></div>",
                                nextArrow: "<div class='nav-right icon-arrow_right'></div>",
                                // focusOnSelect: true,
                                responsive: [
                                  {
                                    breakpoint: 1990,
                                    settings: {
                                      arrows: false
                                    }
                                  },
                                  {
                                    breakpoint: 480,
                                    settings: {
                                      arrows: true
                                    }
                                  }
                                ]
                              });
                        },0)
                    }
                })
                // setTimeout(function(){
                //     var html = $("#slide-voting-result").html();
            
                //     console.log(html);
                //     //
                //     $rootScope.mainOwl.data("owl.carousel").remove(3);
                //     $rootScope.mainOwl.data("owl.carousel").add(html, 4);
                //     $rootScope.mainOwl.data("owl.carousel").refresh();
                // })
                $(".disable-owl-swipe").on("touchstart mousedown", function(e) {
                    // Prevent carousel swipe
                    e.stopPropagation();
                })
                // function stopOwlPropagation(element) {
                // }
            }
        };
        return directive;
    }
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('voteBtnCtrl', voteBtnCtrl);

    voteBtnCtrl.$inject = ['pixerfApiMediaSvc', '$scope', 'toastr', 'messageConst', 'localStorageService', '$rootScope'];

    function voteBtnCtrl(pixerfApiMediaSvc, $scope, toastr, messageConst, localStorageService, $rootScope) {

        var CHOICES = {
            CONFIRM: 'CONFIRM',
            CANCEL: 'CANCEL'
        };

        var self = this;
        self.isConfirming = false;
        self.onVoteBtnClicked = onVoteBtnClicked;
        self.onConfirmBtnClicked = onConfirmBtnClicked;
        self.CHOICES = CHOICES;
        self.isWorking = false;
        self.isVotable = $rootScope.message.votable;

        function doVote(photo){
            if(self.isWorking) return;
            self.isWorking = true;
            var verb = photo.is_voted ? "unvote" : "vote";
            pixerfApiMediaSvc[verb]({
                submission_id:  photo.id
            }, {collusion: localStorageService.cookie.get('collusion')}).$promise.then(function(){
                photo.is_voted = !photo.is_voted;
                self.isWorking = false;
                self.isConfirming = false;
            }, function(err){
                self.isWorking = false;
                self.isConfirming = false;
                var errMsg = messageConst.error.SOME_THING_WRONG;
                if(err.data.reason === "votes_exceeded"){
                    errMsg = messageConst.error.VOTES_EXCEEDED;
                }
                toastr.error(errMsg);
            })
        }

        function onVoteBtnClicked(photo) {
            if(photo.is_voted || !self.isVotable.data) return;
            self.isConfirming = true;
        }
        function onConfirmBtnClicked(choice){
            if(choice === CHOICES.CONFIRM){
                doVote($scope.photo);
            } else {
                self.isConfirming = false;
            }

        }

    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('voteBtn', voteBtn);

  function voteBtn() {

    var directive = {
      scope: {
          photo: "="
      },
      restrict: 'E',
      templateUrl: 'app/components/vote-btn/vote-btn.html',
      controller: 'voteBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('videosPopupCtrl', videosPopupCtrl);

    videosPopupCtrl.$inject = ['messagePopupSvc', '$sce', '$timeout'];

    function videosPopupCtrl(messagePopupSvc, $sce, $timeout) {
        var self = this;

        self.onVideoClicked = onVideoClicked;
        function onVideoClicked(video){
            var videoHtml = _.template('<video id="<%=id%>" poster=<%=poster%> controls playsinline src=<%=source%>  style="width: 100%; height: auto;"></video>')(video);
            var videoHtml = $sce.trustAsHtml(videoHtml);
            self.popup = messagePopupSvc.showPopup({message: videoHtml, size: 'lg', hideOKBtn: true, windowClass: 'videos-popup-modal', backdropClass: 'videos-popup-modal-backdrop'});
            self.popup.rendered.then(function(){
                $timeout(function(){
                    $("#" + video.id)[0].play();
                },300);
            })
        }
    }
})();

(function () {
    angular.module('pixerf')
        .directive('videosPopup', videosPopup);
    function videosPopup() {
        return {
            scope: {
                videos: "="
            },
            restrict: 'E',
            replace: true,
            controller: 'videosPopupCtrl',
            controllerAs: 'vm',
            templateUrl: 'app/components/videos-popup/videos-popup.html'
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('spinnerWin', spinnerWin);
    spinnerWin.$inject = [];
    function spinnerWin() {
        return {
            restrict: 'E',
            scope: {
                "spinner": "=",
                "isOverlayMode": "="
            },
            templateUrl: "app/components/spinner-win/spinner-win.html",
            replace: true
        };
    }
})();                                                                  
(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('scrollPagingCtrl', scrollPagingCtrl);

    scrollPagingCtrl.$inject = ['pagingUtils'];

    function scrollPagingCtrl(pagingUtils) {

        var self = this;
        self.scrollToTop = pagingUtils.scrollToTop;
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('scrollPaging', scrollPaging);
    scrollPaging.$inject = [];
    function scrollPaging() {
        return {
            restrict: 'E',
            scope: {
                "message": '@',
                'spinner': '=',
                'isLastPage': '=',
                'showMessage': '=',
                'hideBackToTop': '='
            },
            templateUrl: "app/components/scroll-paging/scroll-paging.html",
            replace: true,
            controller: 'scrollPagingCtrl',
            controllerAs: 'vm'
        };
    }
})();                                                                  
(function () {
    angular.module('pixerf')
        .directive('progressCircle', progressCircle);
        progressCircle.$inject = ['$timeout']
    function progressCircle($timeout) {
        return {
            scope: {
                progress: '='
            },
            restrict: 'E',
            replace: true,
            templateUrl: 'app/components/progress-circle/progress-circle.html',
            link: function (scope, element) {
                var $element = $(element);
                var $circle = $element.find('#svg #bar');
                var $cont = $element.find('.spinner__progress-container');
                scope.$watch('progress', function(){
                    updateProgress(scope.progress);
                })
                updateProgress(0);
                function updateProgress(val){
    
                    if (isNaN(val)) {
                        val = 100;
                    }
                    else {
                        var r = $circle.attr('r');
                        var c = Math.PI * (r * 2);
    
                        if (val < 0) { val = 0; }
                        if (val > 100) { val = 100; }
    
                        var pct = ((100 - val) / 100) * c;
    
                        $circle.css({ strokeDashoffset: pct });
    
                        $cont.attr('data-pct', val + "%");
                        if(val === 100){
                            $timeout(function(){
                                $cont.attr('data-pct', "Done!");
                            },500);
                        }
                    }
                }
            }
        }
    }
})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('pixerfPhotoSwipeSvc', pixerfPhotoSwipeSvc);

    pixerfPhotoSwipeSvc.$inject = [];

    function pixerfPhotoSwipeSvc(){
        var mInstance = null;

        function setInstance(value){
            mInstance = value;
        }
        function render(data){
            mInstance.render(data);
        }
		return {
            setInstance: setInstance,
            render: render
		};
    }
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('pixerfPhotoSwipeCtrl', pixerfPhotoSwipeCtrl);

    pixerfPhotoSwipeCtrl.$inject = ['$scope', 'pixerfPhotoSwipeSvc'];

    function pixerfPhotoSwipeCtrl($scope, pixerfPhotoSwipeSvc) {

        var self = this;
        
        $scope.instance = self;

        self.currentPhoto = $scope.photos[$scope.startIndex];
        self.onNavigate = onNavigate;
        function getRandomInt(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        }
        function onNavigate(index){
            self.currentPhoto = $scope.photos[index];
            //testing
            // var poolTest = ["This is a short test", "This is a long long test This is a long long testThis is a long long test This is a long long testThis is a long long testThis is a long long testThis is a long long test"]
            // self.currentPhoto.description = poolTest[getRandomInt(0,1)];
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .directive('pixerfPhotoSwipe', pixerfPhotoSwipe);
        pixerfPhotoSwipe.$inject = ['$compile', 'systemUtils'];

    function pixerfPhotoSwipe($compile, systemUtils) {

        var directive = {
            scope: {
                onInit: "&?",
                photos: "=",
                startIndex: '=',
                onNavigate: "&?",
                options: '='
            },
            restrict: 'E',
            templateUrl: 'app/components/pixerf-photo-swipe/pixerf-photo-swipe.html',
            controller: 'pixerfPhotoSwipeCtrl',
            controllerAs: 'vm',
            replace: true,
            link: function (scope, elmt, attrs, ctrl, transcludeFn) {
                var $elmt = $(elmt);
                function init(){
                    for(var i = 0; i < scope.photos.length; i ++){
                        var html = "<div class=\"image-wrapper\"><img class=\"owl-lazy\" data-src=\"" + scope.photos[i].url + "\"><div class=\"overlay\"><i class=\"vertical-align-middle fa fa-spinner fa-spin fa-3x fa-fw  text--theme\"></i></div> </div>";
                        $elmt.find(".owl-carousel").append(html);
                    }
                    $elmt.find(".owl-carousel").owlCarousel({
                        items:1,
                        lazyLoad:true,
                        loop:false,
                        dots: false,
                        startPosition: scope.startIndex,
                        nav: true,
                        navText: ["<div class='icon-arrow_left'></div>","<div class='icon-arrow_right'></div>"],
                        onLoadLazy : function(){
                            console.log('loading..');    
                        }
                        
                    });
                    $elmt.on("translated.owl.carousel", function(event){
                        ctrl.onNavigate(event.item.index);
                        systemUtils.apply(scope);
                    })
                    $elmt.on("load.owl.lazy", function(event){
                        console.log('loading..');
                    })
                    $elmt.on("loaded.owl.lazy", function(event){
                        console.log('loaded!');
                    })
                }
                init();
            }
        };
        return directive;
    }
})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('photoSwipeSvc', photoSwipeSvc);

    photoSwipeSvc.$inject = [];

    function photoSwipeSvc(){
        var mInstance = null;

        function setInstance(value){
            mInstance = value;
        }
        function render(data){
            mInstance.render(data);
        }
		return {
            setInstance: setInstance,
            render: render
		};
    }
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('photoSwipeCtrl', photoSwipeCtrl);

    photoSwipeCtrl.$inject = ['$scope', 'photoSwipeSvc'];

    function photoSwipeCtrl($scope, photoSwipeSvc) {

        var self = this;

        self.currentPhoto = null;
        self.close = function(){
            console.log('dfdfdsf');
        }
        // $scope.onInit({photoSwipeInstance: self});
        photoSwipeSvc.setInstance(self);


    }
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .directive('photoSwipe', photoSwipe);
        photoSwipe.$inject = ['$compile', 'systemUtils'];

    function photoSwipe($compile, systemUtils) {

        var directive = {
            scope: {
                onInit: "&?"
            },
            restrict: 'E',
            templateUrl: 'app/components/photo-swipe/photo-swipe.html',
            controller: 'photoSwipeCtrl',
            controllerAs: 'vm',
            replace: true,
            link: function (scope, elmt, attrs, ctrl, transcludeFn) {
                var gallery;
                function init(data){
                    var pswpElement = $(elmt).find(".pswp")[0];
                    var items = data.items;
                    var options = {
                        barsSize : {top:0,bottom:0},
                        index: data.index,
                        history: false,
                        closeElClasses: [], 
                        captionEl: false,
                        shareEl: false,
                        counterEl: false
                    };
                    gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
                    gallery.init();
                    gallery.listen('afterChange', function() {
                        setCurrentPhoto(items);
                    });
                    setCurrentPhoto(items);
                    initImageMourseHandler();
                }
                function setCurrentPhoto(items){
                    var currentIndex = gallery.getCurrentIndex();
                    ctrl.currentPhoto = items[currentIndex];
                    systemUtils.apply(scope);
                }
                function initImageMourseHandler(){
                    console.log('LOADED');
                    var $container = $(gallery.currItem.container);
                    $container.on("mouseenter.pixerf", "img", function(){
                        console.log('enter');    
                    })
                    $container.on("mouseleave.pixerf", "img", function(){
                        console.log('leave');    
                    })
                }
                function close(){
                    gallery.close();
                }
                ctrl.render = init;
                ctrl.close = close;
                
            }
        };
        return directive;
    }
})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('photoDetailPopupSvc', photoDetailPopupSvc);
    photoDetailPopupSvc.$inject = ['$uibModal'];

    function photoDetailPopupSvc($uibModal){
        function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/photo-detail-popup/photo-detail-popup.html',
				controller: 'photoDetailPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				backdropClass : 'photo-detail-popup-modal-backdrop',
				windowClass: data.windowClass ? (data.windowClass + ' photo-detail-popup-window zindex') : ' photo-detail-popup-window zindex',
				size: data.size ? data.size : '',
				resolve: {
					'popupData': function () {
						return data;
					}
				}
			});

		}

		return {
			showPopup: showPopup
		};
        
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('photoDetailPopupCtrl', photoDetailPopupCtrl);

    photoDetailPopupCtrl.$inject = ['popupData', '$uibModalInstance'];

    function photoDetailPopupCtrl(popupData, $uibModalInstance) {
        var self = this;
        self.popupData = popupData;
        self.closePopup = closePopup;
        
        function closePopup(){
			$uibModalInstance.close();
		}
        
    }
})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('photoGridSvc', photoGridSvc);

    photoGridSvc.$inject = ['fileUtils', 'pixerfApiMediaSvc', 'fileConst'];

    function photoGridSvc(fileUtils, pixerfApiMediaSvc, fileConst){
        function fetchPhotos(searchParam){
            var urlParams = {page: searchParam.page, page_size: fileConst.PHOTO_GRID_PAGE_SIZE};
            return pixerfApiMediaSvc.get_submissions(urlParams).$promise;
        }
		return {
            fetchPhotos: fetchPhotos
		};
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('photoGridCtrl', photoGridCtrl);

    photoGridCtrl.$inject = ['$timeout', '$rootScope', '$scope', 'photoGridSvc', 'fileUtils', 'toastr', 'pagingUtils', 'sessionManagerSvc', '$q', 'arrayUtils', 'numberUtils', 'systemUtils', 'photoSwipeSvc', 'photoDetailPopupSvc'];

    function photoGridCtrl($timeout, $rootScope, $scope, photoGridSvc,  fileUtils, toastr, pagingUtils, sessionManagerSvc, $q, arrayUtils, numberUtils, systemUtils, photoSwipeSvc, photoDetailPopupSvc) {

        var self = this;
        self.containerClass = $scope.container ? $scope.container + " .photo-grid__photos-container" : '';
        self.getFile = getFile;
        self.fetchMorePhotos = fetchMorePhotos;
        self.fetchPhotos = fetchPhotos;
        self.render = render;
        self.onPhotoClicked = onPhotoClicked;
        self.spinner = {isVisible: false};
        self.photos = null;
        self.totalPhotos = 0;
        self.totalPage = 0;
        self.failedToLoadImages = [];
        self.searchParams = null;
        self.isNoMorePhotoToLoad = true;
        $scope.instance = self;
        self.onWindowResize = _.debounce(reRender, 300);
        var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;

       
        function getFile(fileId){
            var found = fileUtils.findFileById(self.photos, fileId);
            return found;
        }
        function fetchPhotos(searchParams, isRefresh){
            var def =  $q.defer();
            if(self.spinner.isVisible){
                def.resolve([]);
                return def.promise;
            }
            self.searchParams = searchParams || {};
            if(!searchParams.page) searchParams.page = 1;


            self.spinner.isVisible = true;
            self.isNoMorePhotoToLoad = false;
            if(isRefresh) {
                reset();
            }
            photoGridSvc.fetchPhotos({page: searchParams.page}).then(function(response){
                self.spinner.isVisible = false;
                if (isRefresh) {
                    self.failedToLoadImages = [];
                    self.photos = [];
                }
                if(response.data.data && response.data.data.length > 0){
                    self.photos = self.photos.concat(response.data.data);
                    render(response.data.data);
                }
                self.searchParams.page = searchParams.page;
                self.isNoMorePhotoToLoad = pagingUtils.isNoMorePageToLoad(self.searchParams.page, response);
                self.totalPhotos = pagingUtils.getTotalCount(response);
                self.totalPage = pagingUtils.getTotalPage(response);
                def.resolve(self);
            }, function(){
                self.spinner.isVisible = false;
                def.reject(self);
            });

            return def.promise;
        }
        function fetchMorePhotos(){
            if(self.spinner.isVisible){
                return;
            }
            fetchPhotos({page: self.searchParams.page+1});           
        }
        function startRendering(photos, failedToLoadImages){
            photos = removeSpoilPhotos(photos, failedToLoadImages);
            generateGrid(photos);
        }
        function generateGrid(photos){
            if(systemUtils.isMobile()){
                self.updateOptions({type: 'mobile'});
                $scope.grid.generateList(photos);
            } else {
                self.updateOptions({type: ''});
                $scope.grid.generate(photos);
            }
        }
        function redraw(){

            startRendering(self.photos, self.failedToLoadImages);
        }
        function render(photos){
            if(photos.length <= 0) return;
            self.spinner.isVisible = true;
            var imageElements = [];
            var loadedImage = 0;
            for(var i=0; i< photos.length; i++){
                imageElements[i] = new Image();
                imageElements[i].setAttribute("class", "image"+i);
                imageElements[i].onload = (function(idx){
                    return function(){
                        loadedImage ++;
                        photos[idx].w = this.width;
                        photos[idx].h = this.height;
                        photos[idx].ar = this.width / this.height;
                        if(loadedImage === photos.length){
                            self.spinner.isVisible = false;
                            self.isFresh = false;
                            startRendering(photos, self.failedToLoadImages);
                        }
                    }
                })(i)
                imageElements[i].onerror = (function(idx){
                    return function(){
                        loadedImage ++;
                        self.failedToLoadImages.push(photos[idx].id);
                        if(loadedImage === photos.length){
                            self.spinner.isVisible = false; 
                            self.isFresh = false;
                            startRendering(photos, self.failedToLoadImages);
                        }
                    }
                })(i)
                var photo = photos[i];
                imageElements[i].src = photo.urlSmall;
            }
        }
        function removeSpoilPhotos(photos, spoilPhotoIds){
            for (var i  = 0; i < spoilPhotoIds.length; i ++){
                photos = _.reject(photos, function(item){
                    return item.id === spoilPhotoIds[i];
                });
            }
            return photos;
        }
        function reRender(){
            if(self.photos.length === 0 || self.spinner.isVisible) return;
            $scope.grid.reset();
            redraw();
        }
        function reset(){
            self.photos = [];
            $scope.grid.reset();
        }
        function onPhotoClicked(photo){
            console.log(photo.id);
            var photos =  removeSpoilPhotos(self.photos, self.failedToLoadImages);
            for(var i = 0; i < photos.length; i ++){
                var photoItem = photos[i];
                photoItem.w = 1024;
                photoItem.h = 1024/photoItem.ar;
                photoItem.src = photoItem.url;
            }
            var index = arrayUtils.indexOf(photos, function(item){
                return item.id === photo.id;
            });
            var selectedPhoto = fileUtils.findFileById(photos,photo.id);
            console.log(index);
            // photoSwipeSvc.render({
            //     items : photos,
            //     index: index
            // })
            photoDetailPopupSvc.showPopup({
                photos: photos,
                index: index,
                selectedPhoto: selectedPhoto,
                photoSwipeOptions: $scope.options
            });

        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('photoGrid', photoGrid);
  photoGrid.$inject = ["$compile"];
  function photoGrid($compile) {

    var directive = {
      scope: {
          hideNoMoreMessage: "=",
          spinner: "=",
          isNoMorePhotoToLoad: "=",
          instance: "=?",
          idealHeight: '=',
          isIgnoreBodyScroll: '=',
          shuffle: '@',
          onPhotoClicked: '&?',
          onPhotoClickedCallback: '&?',
          container: '@?',
          onInit: '&?',
          options: '=?',
          template: '=',
          height: '@',
          onRenderCompleted: '&?'
      },
      transclude: true,
      restrict: 'E',
      templateUrl: 'app/components/photo-grid/photo-grid.html',
      controller: 'photoGridCtrl',
      controllerAs: 'vm',
      replace: true,
      link: function(scope, element, attrs, ctrl){
          function buildItemTemplate(options){
              options = options || {type: ""};

              var str = '<photo ';
              str += ' type="' ;
              str +=  options.type ;
              str +=  '"' ;
              // if(attrs.onPhotoClicked){
                str += ' on-photo-clicked="vm.onPhotoClicked(photo)"';
              // }
              if(attrs.options){
                str += ' options="options"';
              }
              str += 'context="context" file="vm.getFile(<%=id%>)">';
              str += '</photo>';
              return str;
          }
          function updateOptions(options){
              if(scope.grid){
                scope.grid.options.itemTmpl = buildItemTemplate(options);
              }
          }
          var onRenderCompleted = _.debounce(scope.onRenderCompleted, 300);
          var $photosContainer = $(element).find(".photo-grid__photos-container")
          scope.grid = new PhotoGrid({
              idealHeight: ctrl.isMobile ? 150 :  (scope.idealHeight ? scope.idealHeight : Math.max(350, parseInt(window.innerHeight / 3))),
              $container: $photosContainer,
              $parent: scope.container ? $(scope.container + " .photo-grid__photos-container") : $("body"),
              itemTmpl: buildItemTemplate(),
              height: scope.height,
              isIgnoreBodyScroll: scope.isIgnoreBodyScroll,
              events: {
                  beforeItemRendered: function(item, photo, callback){
                       $compile(item)(scope, function(clonedElement){
                          $photosContainer.get(0).appendChild(clonedElement[0]);
                          onRenderCompleted();
                       });
                  }
              }
          });
          //notifiy grid initialize done
          if(attrs.onInit){
              scope.onInit({photoGrid: ctrl});
              ctrl.updateOptions = updateOptions;
      	  }
      }
    };
    return directive;
  }

})();

// Generated by CoffeeScript 1.6.3
var linear_partition, min;

min = function(arr) {
  var computed, result, x, _i, _len;
  for (_i = 0, _len = arr.length; _i < _len; _i++) {
    x = arr[_i];
    computed = x[0];
    if (!result || computed < result.computed) {
      result = {
        value: x,
        computed: computed
      };
    }
  }
  return result.value;
};

linear_partition = function(seq, k) {
  var ans, i, j, m, n, solution, table, x, y, _i, _j, _k, _l;
  n = seq.length;
  if (k <= 0) {
    return [];
  }
  if (k > n) {
    return seq.map(function(x) {
      return [x];
    });
  }
  table = (function() {
    var _i, _results;
    _results = [];
    for (y = _i = 0; 0 <= n ? _i < n : _i > n; y = 0 <= n ? ++_i : --_i) {
      _results.push((function() {
        var _j, _results1;
        _results1 = [];
        for (x = _j = 0; 0 <= k ? _j < k : _j > k; x = 0 <= k ? ++_j : --_j) {
          _results1.push(0);
        }
        return _results1;
      })());
    }
    return _results;
  })();
  solution = (function() {
    var _i, _ref, _results;
    _results = [];
    for (y = _i = 0, _ref = n - 1; 0 <= _ref ? _i < _ref : _i > _ref; y = 0 <= _ref ? ++_i : --_i) {
      _results.push((function() {
        var _j, _ref1, _results1;
        _results1 = [];
        for (x = _j = 0, _ref1 = k - 1; 0 <= _ref1 ? _j < _ref1 : _j > _ref1; x = 0 <= _ref1 ? ++_j : --_j) {
          _results1.push(0);
        }
        return _results1;
      })());
    }
    return _results;
  })();
  for (i = _i = 0; 0 <= n ? _i < n : _i > n; i = 0 <= n ? ++_i : --_i) {
    table[i][0] = seq[i] + (i ? table[i - 1][0] : 0);
  }
  for (j = _j = 0; 0 <= k ? _j < k : _j > k; j = 0 <= k ? ++_j : --_j) {
    table[0][j] = seq[0];
  }
  for (i = _k = 1; 1 <= n ? _k < n : _k > n; i = 1 <= n ? ++_k : --_k) {
    for (j = _l = 1; 1 <= k ? _l < k : _l > k; j = 1 <= k ? ++_l : --_l) {
      m = min((function() {
        var _m, _results;
        _results = [];
        for (x = _m = 0; 0 <= i ? _m < i : _m > i; x = 0 <= i ? ++_m : --_m) {
          _results.push([Math.max(table[x][j - 1], table[i][0] - table[x][0]), x]);
        }
        return _results;
      })());
      table[i][j] = m[0];
      solution[i - 1][j - 1] = m[1];
    }
  }
  n = n - 1;
  k = k - 2;
  ans = [];
  while (k >= 0) {
    ans = [
      (function() {
        var _m, _ref, _ref1, _results;
        _results = [];
        for (i = _m = _ref = solution[n - 1][k] + 1, _ref1 = n + 1; _ref <= _ref1 ? _m < _ref1 : _m > _ref1; i = _ref <= _ref1 ? ++_m : --_m) {
          _results.push(seq[i]);
        }
        return _results;
      })()
    ].concat(ans);
    n = solution[n - 1][k];
    k = k - 1;
  }
  return [
    (function() {
      var _m, _ref, _results;
      _results = [];
      for (i = _m = 0, _ref = n + 1; 0 <= _ref ? _m < _ref : _m > _ref; i = 0 <= _ref ? ++_m : --_m) {
        _results.push(seq[i]);
      }
      return _results;
    })()
  ].concat(ans);
};

part = function (seq, k) {
  if (k <= 0) {
    return [];
  }
  while (k) {
    try {
      return linear_partition(seq, k--);
    } catch (_error) {}
  }
};
function PhotoGrid(options){
	var defaultOptions = {
		idealHeight: parseInt(window.innerHeight / 3),
		spacer: 2,
		itemClass: 'photo',
		itemTmpl: '<div></div>',
		$container: $('.photo-grid__photos-container'),
		isExcludeScrollBar: true,
		isIgnoreBodyScroll: false,
		$parent: $("body"),
		events: {}
	}
	this.options = $.extend(true,defaultOptions, options);
}
PhotoGrid.prototype = (function(){
	function getScrollBarWidth () {
		var $outer = $('<div>').css({visibility: 'hidden', width: 100, overflow: 'scroll'}).appendTo('body'),
			widthWithScroll = $('<div>').css({width: '100%'}).appendTo($outer).outerWidth();
		$outer.remove();
		return 100 - widthWithScroll;
	};
	var V_SCROLL_BAR_WIDTH = getScrollBarWidth();
	function createItem(imageInfo){
		var imgHtml = _.template(this.options.itemTmpl)(imageInfo);
		var $item = $(imgHtml);
		$item.width(imageInfo.w);
		$item.height(imageInfo.h);
		$item.css("margin", this.options.spacer);
		$item.addClass(this.options.itemClass);
		return $item.get(0);
	}
	function isScrollBarVisible($elmt){
		if(this.options.$parent.is("body")){
			return $(document).height() > $(window).height();
		}
		return $elmt.get(0).scrollHeight > $elmt.get(0).clientHeight ;
	}
	function renderItem(photo, viewportWidth, summedRatios, rows){
		var imageInfo = {};
		var respect = rows < 1 ? 'height' : undefined;
		var dimension = calculateImageDimension.call(this, viewportWidth, this.options.idealHeight, summedRatios, photo.ar, respect);
		photo.w = dimension.w;
		photo.h = dimension.h;

		var elem =  createItem.call(this, photo);

		if(this.options.events.beforeItemRendered){
			this.options.events.beforeItemRendered(elem, photo);
		}
		// this.options.$container.get(0).appendChild(elem);
	}
	function calculateImageDimension(viewportWidth, idealHeight, summedRatios, ar, respect, isMobile){
		var dimension = {};
		if(isMobile){
			dimension.w = viewportWidth;
			dimension.h = viewportWidth/ar;
		} else {
			if(respect === "height"){
	
				dimension.h = idealHeight;
				dimension.w = parseInt(idealHeight * ar - 2*this.options.spacer);
			} else {
				dimension.w = parseInt(viewportWidth/ summedRatios * ar - 2*this.options.spacer);
				dimension.h = parseInt(viewportWidth / summedRatios - 2*this.options.spacer);
			}
		}
		return dimension;
		
	}
	function reset(){
		if(this.options.height){
			this.options.$container.css("height", "auto");
		}
		this.options.$container.empty();
		
	}
	function calculateViewportWidth(photos){
		var self = this;
		var padding = 0;
		try{
			var paddingLeft = self.options.$container.css("padding-left").split("px")[0];
			var paddingRight = self.options.$container.css("padding-right").split("px")[0];
	 		padding = (paddingLeft ? parseInt(paddingLeft) : 0) + (paddingRight ? parseInt(paddingRight) : 0);
		}catch(ex){
			padding = 0;
		}
		var viewportWidth = self.options.$container[0].getBoundingClientRect().width - padding;
		if(viewportWidth < 0 ) return;
		if(isScrollBarVisible.call(this, self.options.$container)){
			if($("body").css("over-flow") === "hidden"){
				return viewportWidth - V_SCROLL_BAR_WIDTH;
			}
			return viewportWidth ;
		}
		var summedRatios;
		var sumHeight = 0;
		var summed_width = photos.reduce((function(sum, p) {
	  		return sum += p.ar * self.options.idealHeight;
		}), 0);
		var rows = Math.round(summed_width / viewportWidth);

		summedRatios = photos.reduce((function(sum, p) {
	  		return sum += p.ar;
		}), 0);
		if(rows < 1){
			sumHeight = parseInt(viewportWidth / summedRatios - 2*this.options.spacer);
		} else{
			var weights = photos.map(function(p) {
				return parseInt(p.ar * 100);
			});
			var partition = part(weights, rows);

			var index = 0;
			var rowBuffer = [];
			var imageInfo = {};
			var rowHeight = 0;
			for (var i = 0; i < partition.length; i++) {
				rowBuffer = [];
				for (var j = 0; j<partition[i].length; j++) {
					rowBuffer.push(photos[index++])
				}
				summedRatios = rowBuffer.reduce((function(sum, p) {
					return sum += p.ar;
				}), 0);
				rowHeight = parseInt(viewportWidth / summedRatios - 2*this.options.spacer) + 2*this.options.spacer;
				sumHeight += rowHeight;
			}
		}
		this.options.$container.append('<div id="pixerf-photo-grid" style="height: ' +  sumHeight  +  'px">' + '</div>');
		if(this.options.height && photos.length > 0){
			this.options.$container.css("height", this.options.height);
		}
		if(isScrollBarVisible.call(this, this.options.$container)){
			return viewportWidth - V_SCROLL_BAR_WIDTH;
		}
		$("#pixerf-photo-grid").remove();
		
		return viewportWidth ;
	}
	function generate(photos){
		var self = this;
		this.options.spacer = 2;
		var viewportWidth = calculateViewportWidth.call(this, photos);
		var summedRatios;
		var summed_width = photos.reduce((function(sum, p) {
	  		return sum += p.ar * self.options.idealHeight;
		}), 0);
		var rows = Math.round(summed_width / viewportWidth);

		summedRatios = photos.reduce((function(sum, p) {
	  		return sum += p.ar;
		}), 0);
		if(rows < 1){
			for (var i  = 0; i < photos.length; i ++){
				renderItem.call(this, photos[i], viewportWidth, summedRatios, rows);
			}
		}  else {
			var weights = photos.map(function(p) {
				return parseInt(p.ar * 100);
			});
			var partition = part(weights, rows);
	
			var index = 0;
			var rowBuffer = [];
			var imageInfo = {};
			for (var i = 0; i < partition.length; i++) {
				rowBuffer = [];
				for (var j = 0; j<partition[i].length; j++) {
					rowBuffer.push(photos[index++])
				}
				summedRatios = rowBuffer.reduce((function(sum, p) {
					  return sum += p.ar;
				}), 0);
				for (var k = 0; k<rowBuffer.length; k++) {
					var photo = rowBuffer[k];
					renderItem.call(this, photo,  viewportWidth, summedRatios, rows);
				  }
			}
		}
		// if(this.options.events.onRenderCompleted){
		// 	this.options.events.onRenderCompleted();
		// }
	}
	function generateList(photos){
		var self = this;
		var viewportWidth = calculateViewportWidth.call(this, photos);
		this.options.spacer = "0 0 10px 0";
		for(var i=0; i < photos.length; i ++ ){
			var photo = photos[i];
			photo.w = 'auto';
			photo.h = 'auto';
			var dimension = calculateImageDimension.call(this, viewportWidth, null, null, photo.ar, null, true);
			photo.mobileWidth = dimension.w;
			photo.mobileHeight = dimension.h;
			
			var elem =  createItem.call(self, photo);
			if(self.options.events.beforeItemRendered){
				self.options.events.beforeItemRendered(elem, photo);
			}
			// self.options.$container.get(0).appendChild(elem);
		}
	    // setTimeout(function(){
		// 	if(self.options.events.onRenderCompleted){
		// 		self.options.events.onRenderCompleted();
		// 	}
		// },0);
	}
	return {
		generate: generate,
		generateList: generateList,
		reset: reset
	}
})();
/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('photoSvc', photoSvc);

    photoSvc.$inject = ['pixerfApiMediaSvc', 'galleryUtils', '$q', 'toastr', 'dateUtils', 'messageConst'];

    function photoSvc(pixerfApiMediaSvc, galleryUtils, $q, toastr, dateUtils, messageConst){
        function updateFileGalleriesInfo(file, gallery){
            if(!file.galleries){
                file.galleries = [];
            }
            if(gallery.isSelected){
                file.galleries.push(gallery);
            } else {
                file.galleries = _.reject(file.galleries, function(gal){
                  return gal.id === gallery.id;
                })
            }
        }
        function isUploadedThisWeek(photo){
            var today = moment();
            return dateUtils.isInWeek(photo.inserted_at);
        }
        function addPhotoToGallery(file, gallery){
            var def = $q.defer();
            pixerfApiMediaSvc.add_to_gallery({
                id: file.id,
                gallery_id: gallery.id
            },{}).$promise.then(function(){
                def.resolve();
                updateFileGalleriesInfo(file, gallery);
            }, function(err){
                gallery.isSelected = !gallery.isSelected;
                def.reject(err);
                if(err.data.message){
                    toastr.error(err.data.message);
                } else {
                    toastr.error(messageConst.error.SOME_THING_WRONG);
                }
            });
            return def.promise;
            
        }
        function removePhotoToGallery(file, gallery){
            var def = $q.defer();
            pixerfApiMediaSvc.remove_from_gallery({
                id: file.id,
                gallery_id: gallery.id
            },{}).$promise.then(function(){
                def.resolve();
                updateFileGalleriesInfo(file, gallery);
            }, function(){
                gallery.isSelected = !gallery.isSelected;
                def.reject();
            });;
            return def.promise;
        }
        function likePhoto(file){
            var action = file.is_liked ? 'delete' : 'save';
            return pixerfApiMediaSvc[action]({id: file.id, action: 'likes'}, {}).$promise;
        }
        function transitState(file, state, reason){
            return pixerfApiMediaSvc.update({id: file.id, action: 'state'}, {'state': state , 'reason': reason}).$promise;
        }
        function updatePhotoInfo(photo, override){
            var defer = $q.defer();
            // if(!photo.camera) {
            //      defer.resolve();
            // } else {
                pixerfApiMediaSvc.get({id: photo.id}).$promise.then(function(response){
                    // if(override){
                        for(var key in response.data){
                            photo[key]  = response.data[key];
                        }
                    // } else {
                    //     photo.camera = response.data.camera;
                    //     photo.galleries = response.data.galleries;
                    //     photo.categories = response.data.categories;
                    //     photo.location = response.data.location;
                    //     photo.tags = response.data.tags;
                    //     photo.is_nominated = response.data.is_nominated;
                    //     photo.state = response.data.state;
                    //     photo.is_camera_model_hidden = response.data.is_camera_model_hidden;
                    //     photo.has_model_property = response.data.has_model_property;
                    //     photo.releases = response.data.releases;
                    //     photo.price = response.data.price;
                    //     photo.status = response.data.status;
                    //     photo.is_releasable = response.data.is_releasable;
                    //     photo.is_liked = response.data.is_liked;
                    //     photo.like_count = response.data.like_count;
                    //     photo.inserted_at = response.data.inserted_at;
                    // }
                    defer.resolve();
                }, function(err){
                    if(err.status === 404){
                        toastr.error("Sorry, we cannot find this photo. It may not exist any more.");
                    } else {
                        toastr.error("Failed to retrieve photo details. Please try again.");
                    }
                    defer.reject();
                })
            // }
            return defer.promise;
        }
		return {
            addPhotoToGallery: addPhotoToGallery,
            removePhotoToGallery: removePhotoToGallery,
            likePhoto: likePhoto,
            transitState: transitState,
            updatePhotoInfo: updatePhotoInfo,
            updateFileGalleriesInfo: updateFileGalleriesInfo,
            isUploadedThisWeek: isUploadedThisWeek
		};
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('photoCtrl', photoCtrl);

    photoCtrl.$inject = ['messageConst', 'pixerfApiMediaSvc','$scope', 'toastr', 'sessionManagerSvc', 'photoDetailPopupSvc'];

    function photoCtrl(messageConst, pixerfApiMediaSvc, scope, toastr, sessionManagerSvc, photoDetailPopupSvc) {
        var self = this;
        self.displaySize = scope.displaySize ? scope.displaySize : 'urlSmall';
        self.votePhotoBtnClick = votePhotoBtnClick;
        self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.onPhotoClicked = onPhotoClicked;


        function votePhotoBtnClick(file){
            if(self.isWorking) return;
            self.isWorking = true;
            var verb = file.isVoted ? 'unvote' : 'vote';
            photoSvc[verb](file).then(function(response){
                file.isVoted = !file.isVoted;
                self.isWorking = false;
            }, function(){
                self.isWorking = false;
                toastr.error("Oops! Something went wrong when voting this photo. Please try again");
            })
        }
        function onPhotoClicked(file){

            // photoDetailPopupSvc.showPopup({
            //     photo: file
            // });
            scope.onPhotoClicked({photo: file});
       

        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('photo', photo);
    photo.$inject = ['systemUtils', '$window']
  function photo(systemUtils, $window) {

    var directive = {
      scope: {
          displaySize: "@",
          file: "=",
          context: '=',
          onPhotoClicked: '&?',
          onPhotoClickedCallback: '&?',
          options: '=',
      },
      restrict: 'E',
      templateUrl: function(elemt, attr){
        if(attr.type){
          attr.type = "-" + attr.type;
        }
          return 'app/components/photo/photo' + attr.type + '.html';
      },
      controller: 'photoCtrl',
      controllerAs: 'vm',
      replace: true
   
    };
    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .controller('mainNavCtrl', mainNavCtrl);

  mainNavCtrl.$inject = ['$rootScope'];

  function mainNavCtrl($rootScope) {
    var self = this;
    self.goSlide = goSlide;
    self.toggleMenu = toggleMenu;
    self.isBtnToggleActive = false;
    self.collapseText = 'MENU';
    self.isPublished = $rootScope.message.published;
    function goSlide(slideIndex){
      $rootScope.mainOwl.trigger('to.owl.carousel', slideIndex);
      toggleMenu();
    };
    function toggleMenu(){
      $('#microsite-main-menu').toggleClass('open');
      if(self.isBtnToggleActive){
        self.isBtnToggleActive = false;
        self.collapseText = 'MENU';
        $('body, html').removeClass('overflow-hidden');
      } else {
        self.isBtnToggleActive = true;
        self.collapseText = 'CLOSE';
        $('body, html').addClass('overflow-hidden');
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('mainNav', mainNav);

  function mainNav() {

    var directive = {
      scope: {},
      restrict: 'E',
      templateUrl: 'app/components/main-nav/main-nav.html',
      controller: 'mainNavCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }
})();

/**
 * Controller for home module
 */
(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('messagePopupSvc', messagePopupSvc);
	messagePopupSvc.$inject = ['$uibModalStack', '$uibModal'];

	function messagePopupSvc($uibModalStack, $uibModal) {
		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/message-popup/message-popup.html',
				controller: 'messagePopupCtrl',
				controllerAs: 'vm',
				animation: true,
				backdropClass : data.backdropClass,
				windowClass: data.windowClass ? (data.windowClass + ' message-popup-modal zindex') : ' message-popup-modal zindex',
				size: data.size ? data.size : '',
				resolve: {
					'popupData': function () {
						return data;
					}
				}
			});

		}

		return {
			showPopup: showPopup
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('messagePopupCtrl', messagePopupCtrl);

    messagePopupCtrl.$inject = ['$uibModalInstance', 'popupData'];

    function messagePopupCtrl($uibModalInstance, popupData) {

		var self = this;
		self.closePopup = closePopup;

        self.data = popupData;

		function closePopup(){
			$uibModalInstance.close();
		}
    }
})();
(function () {
	'use strict';

	angular
	  .module('pixerf')
	  .directive('comFooter', comFooter);

	function comFooter() {

	  var directive = {
		scope: {},
		restrict: 'E',
		templateUrl: 'app/components/footer/footer.html',
		replace: true
	  };
	  return directive;
	}
  })();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('systemUtils', systemUtils);

    systemUtils.$inject = ['$timeout'];

    function systemUtils($timeout) {
        function apply(scope){
            $timeout(function(){
                scope.$apply();
            })
        }
        function isMobile(){
            return window.innerWidth < 667;
        }
        function scrollTo(options){
            var body = $("html, body");
            body.stop().animate({ scrollTop: 0 }, '500', 'swing');
        }
    //------------------------------------------------------------------------------------------------------------------
        return {
            apply: apply,
            isMobile: isMobile,
            scrollTo: scrollTo
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('responsiveUtils', responsiveUtils);

    responsiveUtils.$inject = ['$timeout'];

    function responsiveUtils($timeout) {
        
        function isPortrait(){
            var $window = $(window);
            return $window.height() > $window.width();
        }
    //------------------------------------------------------------------------------------------------------------------
        return {
           isPortrait: isPortrait
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('pathUtils', pathUtils);

    pathUtils.$inject = ['fileConst', 'pixerfUrl'];

    function pathUtils(fileConst, pixerfUrl) {
        function getWebrootUrl(){
            return window.location.protocol + "//" + window.location.host;
        }
        function getFallbackFileUrl(){
            return getWebrootUrl()  + "/assets/images/icon-market.png";
        }
        function buildFilePath(fileId, size, type){
            if(!fileId){
                return getFallbackFileUrl();
            }
            return type ? pixerfUrl.full + 'thumbnail/' + type + '/' +  fileId + '/' +  size  : pixerfUrl.full + 'thumbnail/' +  fileId + '/' +  size;
        }
        return {
            getWebrootUrl: getWebrootUrl,
            buildFilePath: buildFilePath,
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('pagingUtils', pagingUtils);

    pagingUtils.$inject = [];

    function pagingUtils() {
        function isNoMorePageToLoad(currentPage, response){
            var totalPage = getTotalPage(response);
            if(typeof currentPage !== "number") currentPage = parseInt(currentPage);
            // var totalPage = 3;
            if(totalPage <= 1) return true;
            return currentPage >= totalPage;
        }
        function scrollToTop(){
            var $target = $("html, body");
            $target.stop().animate({ scrollTop: 0 }, '500', 'swing');

        }
        function getTotalPage(response){
            var pageNum = response.headers("total-pages");
            if(!pageNum) pageNum = response.headers("Total-Pages");
            if(!pageNum) return 0;
            return parseInt(pageNum);
        }
        function getTotalCount(response){
            var totalCount = response.headers("total");
            if(!totalCount) totalCount = response.headers("Total");
            if(!totalCount) return 0;
            return parseInt(totalCount);
        }
    //------------------------------------------------------------------------------------------------------------------
        return {
           isNoMorePageToLoad: isNoMorePageToLoad,
           scrollToTop: scrollToTop,
           getTotalPage: getTotalPage,
           getTotalCount: getTotalCount
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('numberUtils', numberUtils);

    numberUtils.$inject = [];

    function numberUtils() {
        function fraction2Decimal(value){
            try{
                return eval(value);
            }catch(ex){
                return null;
            }
        }
        function parseInt(str){
            try{
                return window.parseInt(str);
            }catch(ex){
                return null;
            }
        }
        function formatNumber(number, separtor, numCharacter){
            separtor = separtor ? separtor : ",";
            numCharacter = numCharacter ? numCharacter : 3;
            if(!number) return "0";
            var re = new RegExp('\\B(?=(\\d{' + numCharacter +  '})+(?!\\d))', 'g');
            return number.toString().replace(re, separtor);
        }
        function getRandomInRange(start, end){
            return Math.floor(Math.random() * end) + start;
        }
        function formatNumberByK(number){
            var thousand = 1000;
            if(number < thousand) return number;
            var mod = number % thousand;
            if(mod === 0){
                return (number/thousand) + "K";
            }
            if(mod < thousand*0.1){
                return (number/thousand).toFixed(0) + 'K';
            }
            return (number/thousand).toFixed(1) + 'K';
        }
    //------------------------------------------------------------------------------------------------------------------
        return {
           fraction2Decimal: fraction2Decimal,
           parseInt: parseInt,
           formatNumber: formatNumber,
           getRandomInRange: getRandomInRange,
           formatNumberByK: formatNumberByK
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('fileUtils', fileUtils);

    fileUtils.$inject = ['fileConst', 'pathUtils', 'sessionManagerSvc'];

    function fileUtils(fileConst, pathUtils, sessionManagerSvc) {
        function findFileById(files, id){
            if(typeof id !=="number") id = parseInt(id);
            return _.find(files, function(p){
                return p.id === id;
            });

        }
        function transform(photo, freshImage){
            // var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
            var fingerPrint = freshImage ? ("?" + new Date().getTime()) : '';
            // photo.badges = badgeUtils.transformBadges(photo.badges);
            photo.url =  pathUtils.buildFilePath(photo.id, "1024x", 's') + fingerPrint;
            photo.urlSmall = pathUtils.buildFilePath(photo.id, "x400", 's') + fingerPrint;
            // photo.thumbnailBig = pathUtils.buildFilePath(photo.id, "x300") + fingerPrint;
            // photo.thumbnail = pathUtils.buildFilePath(photo.id, "160x") + fingerPrint;
            // photo.path = window.location.protocol + "//" + window.location.host + "/#/photo/" + photo.id; 
            // photo.isMine = (mLoginnedUser && photo.user) ? mLoginnedUser.id === photo.user.id : false;
            // photo.price = photo.price == -1 ? null : photo.price;
            // if(photo.user) accountUtils.transformUserData(photo.user);
            // if(!photo.galleries && photo.gallery_ids || (photo.galleries && photo.gallery_ids && photo.gallery_ids.length !== photo.galleries.length)){
            //     photo.galleries = galleryUtils.buildGalleriesFromIds(photo.gallery_ids);
            // }
        }
        function transforms(photos){
            for (var i =0; i < photos.length; i ++){
                transform(photos[i]);
            }
            return photos;          
        } 

    //------------------------------------------------------------------------------------------------------------------
        return {
           findFileById: findFileById,
           transforms: transforms,
           transform: transform
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('arrayUtils', arrayUtils);

    arrayUtils.$inject = [];

    function arrayUtils() {
        function shuffle(array) {
            var currentIndex = array.length, temporaryValue, randomIndex;

            // While there remain elements to shuffle...
            while (0 !== currentIndex) {

                // Pick a remaining element...
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex -= 1;

                // And swap it with the current element.
                temporaryValue = array[currentIndex];
                array[currentIndex] = array[randomIndex];
                array[randomIndex] = temporaryValue;
            }

            return array;
        }
        function indexOf(array, iterator){
            for(var i = 0; i < array.length; i ++){
                if(iterator(array[i])) return i;
            }
            return -1;
        }
        function swapElement(array, one, two){
            var indexOne = _.indexOf(array, one);
            var indexTwo = _.indexOf(array, two);
            if(indexOne !== -1 && indexTwo !== -1) {
                var temp = array[indexOne];
                array[indexOne] = array[indexTwo];
                array[indexTwo] = temp;
            }
        }
        function isEqual(one, two, propertyOne, propertyTwo){
            if((!one && two) || (one && !two)) return false;
            if(one.length !== two.length) return false;
            for (var i = 0; i < one.length; i++){
                var found = _.find(two, function(gl){
                    var oneValue = one[i].hasOwnProperty(propertyOne) ? one[i][propertyOne] : one[i];
                    var twoValue = gl.hasOwnProperty(propertyTwo) ? gl[propertyTwo] : gl;
                    
                    return oneValue === twoValue;

                })
                if(!found) return false;
            }
            return true;
        }
        function getIntersection(arrays, comparedProperty) {
            var i, all, shortest, nShortest, n, len, ret = [], obj={}, nOthers;
            nOthers = arrays.length-1;
            nShortest = arrays[0].length;
            shortest = 0;
            for (i=0; i<=nOthers; i++){
              n = arrays[i].length;
              if (n<nShortest) {
                shortest = i;
                nShortest = n;
              }
            }
          
            for (i=0; i<=nOthers; i++) {
              n = (i===shortest)?0:(i||shortest); //Read the shortest array first. Read the first array instead of the shortest
              len = arrays[n].length;
              for (var j=0; j<len; j++) {
                  var elem = arrays[n][j][comparedProperty];
                  if(obj[elem] === i-1) {
                    if(i === nOthers) {
                      ret.push(arrays[n][j]);
                      obj[elem]=0;
                    } else {
                      obj[elem]=i;
                    }
                  }else if (i===0) {
                    obj[elem]=0;
                  }
              }
            }
            return ret;
        }  
    //------------------------------------------------------------------------------------------------------------------
        return {
           shuffle: shuffle,
           indexOf: indexOf,
           swapElement: swapElement,
           isEqual: isEqual,
           getIntersection: getIntersection
        };
    }
})();
(function(){
'use strict';
  angular
    .module('pixerf')
    .factory('socketSvc', socketSvc);

    socketSvc.$inject = ['pixerfUrl', '$log', 'systemUtils'];
    function socketSvc (pixerfUrl, $log, systemUtils){
        var PIXERF_TOPICS = {
            COLLUSION: {
                name: 'collusion',
                isSubscribed: false
            }
        };
        var mTopicSubscribeStatus = {
            
        }
        var mIsGeneralChannelSubscribed = false;
        var mSocket = null;
        var mGeneralChannel = null;
        var mPrivateChannel = null;
        function connect(){
            if(!mSocket) {
                mSocket = new Phoenix.Socket('wss://' + pixerfUrl.domainOnly + '/socket' , {});
                mSocket.connect();
            }
            mSocket.onOpen(function(){
                $log.info("Socket Open");
            })
            mSocket.onError(function(){
                mSocket = null;
                $log.error("Socket error");
            })
            mSocket.onClose(function(){
                mSocket = null;
                $log.info("Socket close");
            })
        }
        function joinPublicChannel(){
            if(mSocket) return;
            connect();
            mGeneralChannel = mSocket.channel("room:general", {});
            mGeneralChannel.join();
            mGeneralChannel.on("joined" ,function(){
                console.log('joined');
            })
            return mGeneralChannel;
        }
        function joinPrivateChannel(username, token){
            if(mSocket) return;
            connect();
            mPrivateChannel = mSocket.channel("room:" + username, { guardian_token: token });
            mPrivateChannel.join();
        }
        function close(){
            mSocket.close();
        }
        function getPrivateChannel(){
            return mPrivateChannel;
        }
        function getPublicChannel(){
            return mGeneralChannel;
        }
        function subscribeTopic(topic, handler){
            if(mGeneralChannel && mGeneralChannel.state === "joined" && !PIXERF_TOPICS[topic].isSubscribed){
                PIXERF_TOPICS[topic].isSubscribed = true;
                mGeneralChannel.off(PIXERF_TOPICS[topic].name);
                mGeneralChannel.on(PIXERF_TOPICS[topic].name, function(msg){
                    console.log(msg);
                    handler(msg);
                })
                mGeneralChannel.onClose(PIXERF_TOPICS.NOTIFICATIONS, function(msg){
                    PIXERF_TOPICS[topic].isSubscribed = false;
                })
                mGeneralChannel.onError(PIXERF_TOPICS.NOTIFICATIONS, function(msg){
                    PIXERF_TOPICS[topic].isSubscribed = false;
                })
            }
        }


        return { 
            joinPrivateChannel: joinPrivateChannel,
            joinPublicChannel: joinPublicChannel,
            getPrivateChannel: getPrivateChannel,
            getPublicChannel: getPublicChannel,
            PIXERF_TOPICS: PIXERF_TOPICS,
            subscribeTopic: subscribeTopic
        };
    }
})();

(function(){

  angular
    .module('pixerf')
    .factory('sessionManagerSvc', sessionManagerSvc);

    sessionManagerSvc.$inject = ['localStorageService', '$rootScope', '$location', 'messageConst'];

    function sessionManagerSvc(localStorageService, $rootScope, $location, messageConst){
    	var CALLBACK_URL = "PIXERF.CALLBACK_URL";
        var TOKEN  = "PIXERF.TOKEN";
        var PROFILE = "PIXERF.PROFILE";
        var USER = "PIXERF.LOGIN_USER";
        var SIGNING_UP_USER = "PIXERF.SIGNING_UP_USER";
        var FIRST_TIME_LOGIN = "PIXERF.FIRST_TIME_LOGIN";
        var RESET_PASSOWRD_REDIRECT = "PIXERF.RESET_PASSOWRD_REDIRECT";
        var MARKETPLACE_HISTORY = "PIXERF.LAST_MARKETPLACE_TAB";

        var mCurrentLoginUser = {data: null};
        function setCurrentLoginUser(user){
            var cloned = null;
            if(user){
                cloned = $.extend(true, {}, user);
            }
            mCurrentLoginUser.data = cloned;
            $rootScope.$broadcast(messageConst.BROADCAST.USER_DATA_CHANGE);
        }
        function getCurrentLoginUser(){
            if(!mCurrentLoginUser.data) return mCurrentLoginUser;
            var cloned = $.extend(true, {}, mCurrentLoginUser);
            return cloned;
        }
        function setToken(token){
            localStorageService.set(TOKEN, token);
        }
        function getToken(){
            return localStorageService.get(TOKEN);
        }
        function setResetPasswordRedirect(data){
            localStorageService.set(RESET_PASSOWRD_REDIRECT, data);
        }
        function getResetPasswordRedirect(){
            return localStorageService.get(RESET_PASSOWRD_REDIRECT);
        }
        function setProfile(profile){
            localStorageService.set(PROFILE, profile);
        }
        function getProfile(){
            return localStorageService.get(PROFILE);
        }
        function setSigningUpUser(user){
            localStorageService.set(SIGNING_UP_USER, user);
        }
        function getSigningUpUser(){
            return localStorageService.get(SIGNING_UP_USER);
        }
        function setFirstTimeLogin(value){
            localStorageService.set(FIRST_TIME_LOGIN, value);
        }
        function getFirstTimeLogin(){
            return localStorageService.get(FIRST_TIME_LOGIN);
        }
        function clearSession(){
            setToken(null);
            setCurrentLoginUser(null);
            setProfile(null);
        }
        function isMine(owner){
            return mCurrentLoginUser.data && mCurrentLoginUser.data.id === owner.id;
        }
        function isMyPhoto(photo){
            if(!photo.user) return true;
            return mCurrentLoginUser.data && mCurrentLoginUser.data.id === photo.user.id;
        }
		return {
			setCurrentLoginUser: setCurrentLoginUser,
            getCurrentLoginUser: getCurrentLoginUser,
            setProfile: setProfile,
            getProfile: getProfile,
            setSigningUpUser: setSigningUpUser,
            getSigningUpUser: getSigningUpUser,
            getToken: getToken,
            setToken: setToken,
            clearSession: clearSession,
            isMine: isMine,
            isMyPhoto: isMyPhoto,
		};
    }
})();

(function () {
    'use strict';
    angular
        .module('pixerf')
        .factory('pixerfApiMediaSvc', pixerfApiMediaSvc);

    pixerfApiMediaSvc.$inject = ['$resource', 'pixerfUrl', 'fileUtils', 'localStorageService'];

    function pixerfApiMediaSvc($resource, pixerfUrl, fileUtils, localStorageService) {
        return $resource(pixerfUrl.full + 'api/submissions', {}, {
            'get_submissions': {
                method: 'GET',
                interceptor: {
                    response: function (response) {
                        // response.data = [{"width":2895,"user_selection":{"license":"editorial","id":"62bcd0c5-4fea-46bb-b612-e59f07c9108c","has_model_property":false},"user":{"username":"auth0|5951100b68cfaf2f00c994db","profile_image":"018rqDRNzl5Y2BevdgxG","organization":null,"last_name":"Test","is_followed":false,"is_ambassador":false,"id":1309,"first_name":"Pilot","ambassadorship":null,"account_type":"personal"},"title":"iStock_73975189_LARGE","tags":null,"state":"d","star_count":1,"reject_reason":null,"nomination_count":3,"like_count":8,"license":"commercial","is_starred":false,"is_releasable":false,"is_published":false,"is_nominated":false,"is_liked":false,"inserted_at":"2017-06-30T04:33:46","in_mission":false,"id":11175,"height":1697,"has_model_property":false,"has_adult_content":false,"handle":"DJ5g1opNZQDJV3vLzZe4","gallery_ids":[1790],"filename":"iStock_73975189_LARGE.jpg","description":null,"comment_count":2},{"width":5184,"user_selection":{"license":"editorial","id":"0190f48d-0481-4dd9-8486-487bfd40b49c","has_model_property":false},"user":{"username":"auth0|5875e172e8e62d2d9e213000","profile_image":"XdQ5yl7VGXovNMLD1gqZ","organization":null,"last_name":"Nhut Dinh","is_followed":false,"is_ambassador":true,"id":27,"first_name":"Nick","ambassadorship":"maestro","account_type":"personal"},"title":"Category - Family","tags":null,"state":"d","star_count":1,"reject_reason":null,"nomination_count":1,"like_count":3,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":true,"is_nominated":false,"is_liked":false,"inserted_at":"2017-03-07T11:31:36","in_mission":false,"id":2544,"height":3456,"has_model_property":false,"has_adult_content":false,"handle":"dr4B5rPhRUxH9lh4cxpA","gallery_ids":[940,1625,1685],"filename":"nature-forest-industry-rails - Copy (3).jpg","description":"DO NOT DELETE","comment_count":0},{"width":2713,"user_selection":{"license":"commercial","id":"03f32ef8-2b54-4078-8caa-a3fd4d15e621","has_model_property":true},"user":{"username":"auth0|58db38819351c02ed1804250","profile_image":"ZdM5keP2p6YKNnavO67R","organization":null,"last_name":"Choo","is_followed":false,"is_ambassador":true,"id":484,"first_name":"Medinaa","ambassadorship":"maestro","account_type":"personal"},"title":"iStock_84356717_LARGE","tags":null,"state":"d","star_count":1,"reject_reason":null,"nomination_count":0,"like_count":7,"license":"commercial","is_starred":false,"is_releasable":false,"is_published":true,"is_nominated":false,"is_liked":false,"inserted_at":"2017-04-03T04:55:04","in_mission":true,"id":3064,"height":1811,"has_model_property":false,"has_adult_content":false,"handle":"ds39K7NLRQGn9yNRGT9U","gallery_ids":[763,940,702],"filename":"iStock_84356717_LARGE.jpg","description":null,"comment_count":1},{"width":2650,"user_selection":{"license":"editorial","id":"18f64b93-78d5-4ace-897b-469b5fb94c64","has_model_property":false},"user":{"username":"auth0|5904b15f51ad1605c47627cc","profile_image":null,"organization":null,"last_name":"Photos","is_followed":false,"is_ambassador":false,"id":865,"first_name":"Seller","ambassadorship":null,"account_type":"personal"},"title":"iStock_80509845_MEDIUM","tags":null,"state":"d","star_count":1,"reject_reason":null,"nomination_count":1,"like_count":0,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":true,"is_nominated":false,"is_liked":false,"inserted_at":"2017-05-04T13:02:05","in_mission":false,"id":4552,"height":1606,"has_model_property":false,"has_adult_content":false,"handle":"qO028YzmQyOaLGvXBgB4","gallery_ids":[1804],"filename":"iStock_80509845_MEDIUM.jpg","description":null,"comment_count":0},{"width":4000,"user_selection":{"license":"editorial","id":"afa4b8ae-63f7-404b-b9e4-7f6be72aa633","has_model_property":false},"user":{"username":"auth0|58c64ba2947960750c25ce8f","profile_image":"gs2Xo4kwSjuTNQMHuIaK","organization":null,"last_name":"Vader","is_followed":false,"is_ambassador":false,"id":434,"first_name":"Darth","ambassadorship":null,"account_type":"personal"},"title":"fdfdfdf","tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":1,"like_count":2,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":null,"is_nominated":false,"is_liked":false,"inserted_at":"2017-02-17T12:14:31","in_mission":false,"id":1255,"height":2670,"has_model_property":false,"has_adult_content":false,"handle":"R4SokttOTCWBuStyvlDb","gallery_ids":null,"filename":"jaguar-animal-wallpaper-high-quality-resolution.jpg","description":null,"comment_count":3},{"width":2713,"user_selection":{"license":"editorial","id":"6e273163-172b-453e-9e11-a78b18ccfb4e","has_model_property":false},"user":{"username":"auth0|58c64ba2947960750c25ce8f","profile_image":"gs2Xo4kwSjuTNQMHuIaK","organization":null,"last_name":"Vader","is_followed":false,"is_ambassador":false,"id":434,"first_name":"Darth","ambassadorship":null,"account_type":"personal"},"title":null,"tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":1,"like_count":1,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":null,"is_nominated":false,"is_liked":false,"inserted_at":"2017-05-04T14:56:03","in_mission":false,"id":4613,"height":1811,"has_model_property":false,"has_adult_content":false,"handle":"FKaLaR70ShKE9oo6uet5","gallery_ids":null,"filename":"iStock_73009259_LARGE.jpg","description":null,"comment_count":0},{"width":4096,"user_selection":{"license":"editorial","id":"d66c3bde-9832-47ce-8f11-07affc213610","has_model_property":false},"user":{"username":"auth0|5875e172e8e62d2d9e213000","profile_image":"XdQ5yl7VGXovNMLD1gqZ","organization":null,"last_name":"Nhut Dinh","is_followed":false,"is_ambassador":true,"id":27,"first_name":"Nick","ambassadorship":"maestro","account_type":"personal"},"title":"Nature-Spring-032","tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":0,"like_count":3,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":true,"is_nominated":false,"is_liked":false,"inserted_at":"2017-03-02T08:42:32","in_mission":false,"id":2237,"height":2304,"has_model_property":false,"has_adult_content":false,"handle":"pigS2O9jTDizaWF7cWK4","gallery_ids":[763,940],"filename":"Nature-Spring-032.jpg","description":null,"comment_count":0},{"width":2988,"user_selection":{"license":"commercial","id":"af2bcd5d-5070-4167-828b-a7ad4049382c","has_model_property":false},"user":{"username":"auth0|587c9dbe85cf4168913f1f47","profile_image":"48Py07OVbkqoNn9grRGW","organization":null,"last_name":"Omar","is_followed":false,"is_ambassador":false,"id":56,"first_name":"Zaiyid","ambassadorship":null,"account_type":"personal"},"title":"Again","tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":0,"like_count":1,"license":"commercial","is_starred":false,"is_releasable":false,"is_published":false,"is_nominated":false,"is_liked":false,"inserted_at":"2018-01-11T02:32:06","in_mission":false,"id":16193,"height":5312,"has_model_property":false,"has_adult_content":false,"handle":"MDmXWvpEygnbV7LodZKq","gallery_ids":null,"filename":"JPEG_20180111_075108_1496052086.jpg","description":null,"comment_count":0},{"width":1920,"user_selection":{"license":"editorial","id":"09e2517d-9af6-46e1-920c-a2504f593009","has_model_property":false},"user":{"username":"auth0|58c64ba2947960750c25ce8f","profile_image":"gs2Xo4kwSjuTNQMHuIaK","organization":null,"last_name":"Vader","is_followed":false,"is_ambassador":false,"id":434,"first_name":"Darth","ambassadorship":null,"account_type":"personal"},"title":null,"tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":1,"like_count":0,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":null,"is_nominated":false,"is_liked":false,"inserted_at":"2017-02-20T03:21:35","in_mission":false,"id":1381,"height":1080,"has_model_property":false,"has_adult_content":false,"handle":"UPPkSG9TNa57ozVmlhjW","gallery_ids":null,"filename":"maxresdefault.jpg","description":null,"comment_count":0},{"width":4288,"user_selection":{"license":"editorial","id":"e72d6c79-d476-42c9-a717-21ecffbe8910","has_model_property":false},"user":{"username":"auth0|590c08092818e30c81e713dd","profile_image":"ZxrQLAwVRzRmVmnWqB5z","organization":null,"last_name":"test","is_followed":false,"is_ambassador":true,"id":992,"first_name":"may","ambassadorship":"maestro","account_type":"personal"},"title":"edit","tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":1,"like_count":0,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":true,"is_nominated":false,"is_liked":false,"inserted_at":"2017-05-05T06:09:04","in_mission":false,"id":4768,"height":2848,"has_model_property":false,"has_adult_content":false,"handle":"eGV7AOPSTmqEegg70hr6","gallery_ids":null,"filename":"13.jpg","description":null,"comment_count":0},{"width":2988,"user_selection":{"license":"editorial","id":"0eb81a25-94b5-4449-be4f-3686ce1296e6","has_model_property":false},"user":{"username":"auth0|587c9dbe85cf4168913f1f47","profile_image":"48Py07OVbkqoNn9grRGW","organization":null,"last_name":"Omar","is_followed":false,"is_ambassador":false,"id":56,"first_name":"Zaiyid","ambassadorship":null,"account_type":"personal"},"title":"landscape 2ieuejrjrnfjfkf fjdjjf ndjdj djjdjd djdj","tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":0,"like_count":2,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":false,"is_nominated":false,"is_liked":false,"inserted_at":"2017-12-28T14:12:27","in_mission":false,"id":15954,"height":5312,"has_model_property":false,"has_adult_content":false,"handle":"W4r9JbYELmoP2GK73mXM","gallery_ids":null,"filename":"JPEG_20171228_194152_727796607.jpg","description":null,"comment_count":0},{"width":3200,"user_selection":{"license":"editorial","id":"92d0d2f5-feaa-40e2-af05-7ae0b3626165","has_model_property":false},"user":{"username":"facebook|470702319986326","profile_image":"L8YzZ7KE7ke1EGbJw9Bv","organization":null,"last_name":"Cao","is_followed":false,"is_ambassador":true,"id":233,"first_name":"Henry","ambassadorship":"maestro","account_type":"personal"},"title":"Tamen a proposito","tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":1,"like_count":0,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":false,"is_nominated":false,"is_liked":false,"inserted_at":"2018-01-04T08:58:05","in_mission":false,"id":16043,"height":1600,"has_model_property":false,"has_adult_content":false,"handle":"6KlZ9ymVYOoYEpzYJ0k3","gallery_ids":[1800],"filename":"3200x1600.jpg","description":"Vide, quaeso, rectumne sit. Equidem e Cn. Duo Reges: constructio interrete. Scaevolam M. An potest cupiditas finiri","comment_count":1},{"width":4096,"user_selection":{"license":"editorial","id":"64511732-a455-44ed-9fec-b8390f0e4791","has_model_property":false},"user":{"username":"auth0|58c64ba2947960750c25ce8f","profile_image":"gs2Xo4kwSjuTNQMHuIaK","organization":null,"last_name":"Vader","is_followed":false,"is_ambassador":false,"id":434,"first_name":"Darth","ambassadorship":null,"account_type":"personal"},"title":null,"tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":1,"like_count":0,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":null,"is_nominated":false,"is_liked":false,"inserted_at":"2017-02-17T02:11:35","in_mission":false,"id":1064,"height":2304,"has_model_property":false,"has_adult_content":false,"handle":"UOSsstMSSxq8AnHHm7wk","gallery_ids":null,"filename":"Nature-Spring-032.jpg","description":null,"comment_count":0},{"width":null,"user_selection":{"license":"editorial","id":"9ca31c99-3e62-4090-840c-b39458ff6a86","has_model_property":false},"user":{"username":"auth0|58c64ba2947960750c25ce8f","profile_image":"gs2Xo4kwSjuTNQMHuIaK","organization":null,"last_name":"Vader","is_followed":false,"is_ambassador":false,"id":434,"first_name":"Darth","ambassadorship":null,"account_type":"personal"},"title":null,"tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":0,"like_count":1,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":null,"is_nominated":false,"is_liked":false,"inserted_at":"2017-04-25T04:10:10","in_mission":false,"id":4108,"height":null,"has_model_property":false,"has_adult_content":false,"handle":"tq1OdOVVTsa0ABHEIFv0","gallery_ids":null,"filename":"temp.obj","description":null,"comment_count":0},{"width":2713,"user_selection":{"license":"editorial","id":"86772193-d459-4eb9-aff0-08168489c8f3","has_model_property":false},"user":{"username":"auth0|590b270c51ad1605c47a7b9b","profile_image":null,"organization":null,"last_name":"Test","is_followed":false,"is_ambassador":true,"id":985,"first_name":"Upload","ambassadorship":"pro","account_type":"personal"},"title":"iStock_84356717_LARGE","tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":0,"like_count":1,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":true,"is_nominated":false,"is_liked":false,"inserted_at":"2017-05-04T15:21:04","in_mission":false,"id":4653,"height":1811,"has_model_property":false,"has_adult_content":false,"handle":"0v9N2qu4Rmebtq4dmHWQ","gallery_ids":null,"filename":"iStock_84356717_LARGE.jpg","description":null,"comment_count":0},{"width":4096,"user_selection":{"license":"editorial","id":"f03af134-a1ff-424b-8f39-8497f80cbe55","has_model_property":false},"user":{"username":"auth0|58c64ba2947960750c25ce8f","profile_image":"gs2Xo4kwSjuTNQMHuIaK","organization":null,"last_name":"Vader","is_followed":false,"is_ambassador":false,"id":434,"first_name":"Darth","ambassadorship":null,"account_type":"personal"},"title":null,"tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":0,"like_count":1,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":null,"is_nominated":false,"is_liked":false,"inserted_at":"2017-03-02T08:40:31","in_mission":false,"id":2227,"height":2304,"has_model_property":false,"has_adult_content":false,"handle":"fLuxAsVoSQKDuk6CNFLt","gallery_ids":null,"filename":"Nature-Spring-032.jpg","description":null,"comment_count":0},{"width":6000,"user_selection":{"license":"editorial","id":"a16b7c8a-a321-43fe-a38f-948ae6207ec4","has_model_property":false},"user":{"username":"auth0|5875e172e8e62d2d9e213000","profile_image":"XdQ5yl7VGXovNMLD1gqZ","organization":null,"last_name":"Nhut Dinh","is_followed":false,"is_ambassador":true,"id":27,"first_name":"Nick","ambassadorship":"maestro","account_type":"personal"},"title":"DSC07075_RT","tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":0,"like_count":1,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":true,"is_nominated":false,"is_liked":false,"inserted_at":"2017-05-05T02:39:19","in_mission":false,"id":4681,"height":4000,"has_model_property":false,"has_adult_content":false,"handle":"EVAscAERRi0FDZv0DiwG","gallery_ids":null,"filename":"DSC07075_RT.jpg","description":null,"comment_count":0}]
                        fileUtils.transforms(response.data.data);
                        return response;
                    }
                    // ,
                    // responseError: function (response) {
                    //     response.data = {data:[{"width":2895,"user_selection":{"license":"editorial","id":"62bcd0c5-4fea-46bb-b612-e59f07c9108c","has_model_property":false},"user":{"username":"auth0|5951100b68cfaf2f00c994db","profile_image":"018rqDRNzl5Y2BevdgxG","organization":null,"last_name":"Test","is_followed":false,"is_ambassador":false,"id":1309,"first_name":"Pilot","ambassadorship":null,"account_type":"personal"},"title":"iStock_73975189_LARGE","tags":null,"state":"d","star_count":1,"reject_reason":null,"nomination_count":3,"like_count":8,"license":"commercial","is_starred":false,"is_releasable":false,"is_published":false,"is_nominated":false,"is_liked":false,"inserted_at":"2017-06-30T04:33:46","in_mission":false,"id":11175,"height":1697,"has_model_property":false,"has_adult_content":false,"handle":"DJ5g1opNZQDJV3vLzZe4","gallery_ids":[1790],"filename":"iStock_73975189_LARGE.jpg","description":null,"comment_count":2},{"width":5184,"user_selection":{"license":"editorial","id":"0190f48d-0481-4dd9-8486-487bfd40b49c","has_model_property":false},"user":{"username":"auth0|5875e172e8e62d2d9e213000","profile_image":"XdQ5yl7VGXovNMLD1gqZ","organization":null,"last_name":"Nhut Dinh","is_followed":false,"is_ambassador":true,"id":27,"first_name":"Nick","ambassadorship":"maestro","account_type":"personal"},"title":"Category - Family","tags":null,"state":"d","star_count":1,"reject_reason":null,"nomination_count":1,"like_count":3,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":true,"is_nominated":false,"is_liked":false,"inserted_at":"2017-03-07T11:31:36","in_mission":false,"id":2544,"height":3456,"has_model_property":false,"has_adult_content":false,"handle":"dr4B5rPhRUxH9lh4cxpA","gallery_ids":[940,1625,1685],"filename":"nature-forest-industry-rails - Copy (3).jpg","description":"DO NOT DELETE","comment_count":0},{"width":2713,"user_selection":{"license":"commercial","id":"03f32ef8-2b54-4078-8caa-a3fd4d15e621","has_model_property":true},"user":{"username":"auth0|58db38819351c02ed1804250","profile_image":"ZdM5keP2p6YKNnavO67R","organization":null,"last_name":"Choo","is_followed":false,"is_ambassador":true,"id":484,"first_name":"Medinaa","ambassadorship":"maestro","account_type":"personal"},"title":"iStock_84356717_LARGE","tags":null,"state":"d","star_count":1,"reject_reason":null,"nomination_count":0,"like_count":7,"license":"commercial","is_starred":false,"is_releasable":false,"is_published":true,"is_nominated":false,"is_liked":false,"inserted_at":"2017-04-03T04:55:04","in_mission":true,"id":3064,"height":1811,"has_model_property":false,"has_adult_content":false,"handle":"ds39K7NLRQGn9yNRGT9U","gallery_ids":[763,940,702],"filename":"iStock_84356717_LARGE.jpg","description":null,"comment_count":1},{"width":2650,"user_selection":{"license":"editorial","id":"18f64b93-78d5-4ace-897b-469b5fb94c64","has_model_property":false},"user":{"username":"auth0|5904b15f51ad1605c47627cc","profile_image":null,"organization":null,"last_name":"Photos","is_followed":false,"is_ambassador":false,"id":865,"first_name":"Seller","ambassadorship":null,"account_type":"personal"},"title":"iStock_80509845_MEDIUM","tags":null,"state":"d","star_count":1,"reject_reason":null,"nomination_count":1,"like_count":0,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":true,"is_nominated":false,"is_liked":false,"inserted_at":"2017-05-04T13:02:05","in_mission":false,"id":4552,"height":1606,"has_model_property":false,"has_adult_content":false,"handle":"qO028YzmQyOaLGvXBgB4","gallery_ids":[1804],"filename":"iStock_80509845_MEDIUM.jpg","description":null,"comment_count":0},{"width":4000,"user_selection":{"license":"editorial","id":"afa4b8ae-63f7-404b-b9e4-7f6be72aa633","has_model_property":false},"user":{"username":"auth0|58c64ba2947960750c25ce8f","profile_image":"gs2Xo4kwSjuTNQMHuIaK","organization":null,"last_name":"Vader","is_followed":false,"is_ambassador":false,"id":434,"first_name":"Darth","ambassadorship":null,"account_type":"personal"},"title":"fdfdfdf","tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":1,"like_count":2,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":null,"is_nominated":false,"is_liked":false,"inserted_at":"2017-02-17T12:14:31","in_mission":false,"id":1255,"height":2670,"has_model_property":false,"has_adult_content":false,"handle":"R4SokttOTCWBuStyvlDb","gallery_ids":null,"filename":"jaguar-animal-wallpaper-high-quality-resolution.jpg","description":null,"comment_count":3},{"width":2713,"user_selection":{"license":"editorial","id":"6e273163-172b-453e-9e11-a78b18ccfb4e","has_model_property":false},"user":{"username":"auth0|58c64ba2947960750c25ce8f","profile_image":"gs2Xo4kwSjuTNQMHuIaK","organization":null,"last_name":"Vader","is_followed":false,"is_ambassador":false,"id":434,"first_name":"Darth","ambassadorship":null,"account_type":"personal"},"title":null,"tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":1,"like_count":1,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":null,"is_nominated":false,"is_liked":false,"inserted_at":"2017-05-04T14:56:03","in_mission":false,"id":4613,"height":1811,"has_model_property":false,"has_adult_content":false,"handle":"FKaLaR70ShKE9oo6uet5","gallery_ids":null,"filename":"iStock_73009259_LARGE.jpg","description":null,"comment_count":0},{"width":4096,"user_selection":{"license":"editorial","id":"d66c3bde-9832-47ce-8f11-07affc213610","has_model_property":false},"user":{"username":"auth0|5875e172e8e62d2d9e213000","profile_image":"XdQ5yl7VGXovNMLD1gqZ","organization":null,"last_name":"Nhut Dinh","is_followed":false,"is_ambassador":true,"id":27,"first_name":"Nick","ambassadorship":"maestro","account_type":"personal"},"title":"Nature-Spring-032","tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":0,"like_count":3,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":true,"is_nominated":false,"is_liked":false,"inserted_at":"2017-03-02T08:42:32","in_mission":false,"id":2237,"height":2304,"has_model_property":false,"has_adult_content":false,"handle":"pigS2O9jTDizaWF7cWK4","gallery_ids":[763,940],"filename":"Nature-Spring-032.jpg","description":null,"comment_count":0},{"width":2988,"user_selection":{"license":"commercial","id":"af2bcd5d-5070-4167-828b-a7ad4049382c","has_model_property":false},"user":{"username":"auth0|587c9dbe85cf4168913f1f47","profile_image":"48Py07OVbkqoNn9grRGW","organization":null,"last_name":"Omar","is_followed":false,"is_ambassador":false,"id":56,"first_name":"Zaiyid","ambassadorship":null,"account_type":"personal"},"title":"Again","tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":0,"like_count":1,"license":"commercial","is_starred":false,"is_releasable":false,"is_published":false,"is_nominated":false,"is_liked":false,"inserted_at":"2018-01-11T02:32:06","in_mission":false,"id":16193,"height":5312,"has_model_property":false,"has_adult_content":false,"handle":"MDmXWvpEygnbV7LodZKq","gallery_ids":null,"filename":"JPEG_20180111_075108_1496052086.jpg","description":null,"comment_count":0},{"width":1920,"user_selection":{"license":"editorial","id":"09e2517d-9af6-46e1-920c-a2504f593009","has_model_property":false},"user":{"username":"auth0|58c64ba2947960750c25ce8f","profile_image":"gs2Xo4kwSjuTNQMHuIaK","organization":null,"last_name":"Vader","is_followed":false,"is_ambassador":false,"id":434,"first_name":"Darth","ambassadorship":null,"account_type":"personal"},"title":null,"tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":1,"like_count":0,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":null,"is_nominated":false,"is_liked":false,"inserted_at":"2017-02-20T03:21:35","in_mission":false,"id":1381,"height":1080,"has_model_property":false,"has_adult_content":false,"handle":"UPPkSG9TNa57ozVmlhjW","gallery_ids":null,"filename":"maxresdefault.jpg","description":null,"comment_count":0},{"width":4288,"user_selection":{"license":"editorial","id":"e72d6c79-d476-42c9-a717-21ecffbe8910","has_model_property":false},"user":{"username":"auth0|590c08092818e30c81e713dd","profile_image":"ZxrQLAwVRzRmVmnWqB5z","organization":null,"last_name":"test","is_followed":false,"is_ambassador":true,"id":992,"first_name":"may","ambassadorship":"maestro","account_type":"personal"},"title":"edit","tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":1,"like_count":0,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":true,"is_nominated":false,"is_liked":false,"inserted_at":"2017-05-05T06:09:04","in_mission":false,"id":4768,"height":2848,"has_model_property":false,"has_adult_content":false,"handle":"eGV7AOPSTmqEegg70hr6","gallery_ids":null,"filename":"13.jpg","description":null,"comment_count":0},{"width":2988,"user_selection":{"license":"editorial","id":"0eb81a25-94b5-4449-be4f-3686ce1296e6","has_model_property":false},"user":{"username":"auth0|587c9dbe85cf4168913f1f47","profile_image":"48Py07OVbkqoNn9grRGW","organization":null,"last_name":"Omar","is_followed":false,"is_ambassador":false,"id":56,"first_name":"Zaiyid","ambassadorship":null,"account_type":"personal"},"title":"landscape 2ieuejrjrnfjfkf fjdjjf ndjdj djjdjd djdj","tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":0,"like_count":2,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":false,"is_nominated":false,"is_liked":false,"inserted_at":"2017-12-28T14:12:27","in_mission":false,"id":15954,"height":5312,"has_model_property":false,"has_adult_content":false,"handle":"W4r9JbYELmoP2GK73mXM","gallery_ids":null,"filename":"JPEG_20171228_194152_727796607.jpg","description":null,"comment_count":0},{"width":3200,"user_selection":{"license":"editorial","id":"92d0d2f5-feaa-40e2-af05-7ae0b3626165","has_model_property":false},"user":{"username":"facebook|470702319986326","profile_image":"L8YzZ7KE7ke1EGbJw9Bv","organization":null,"last_name":"Cao","is_followed":false,"is_ambassador":true,"id":233,"first_name":"Henry","ambassadorship":"maestro","account_type":"personal"},"title":"Tamen a proposito","tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":1,"like_count":0,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":false,"is_nominated":false,"is_liked":false,"inserted_at":"2018-01-04T08:58:05","in_mission":false,"id":16043,"height":1600,"has_model_property":false,"has_adult_content":false,"handle":"6KlZ9ymVYOoYEpzYJ0k3","gallery_ids":[1800],"filename":"3200x1600.jpg","description":"Vide, quaeso, rectumne sit. Equidem e Cn. Duo Reges: constructio interrete. Scaevolam M. An potest cupiditas finiri","comment_count":1},{"width":4096,"user_selection":{"license":"editorial","id":"64511732-a455-44ed-9fec-b8390f0e4791","has_model_property":false},"user":{"username":"auth0|58c64ba2947960750c25ce8f","profile_image":"gs2Xo4kwSjuTNQMHuIaK","organization":null,"last_name":"Vader","is_followed":false,"is_ambassador":false,"id":434,"first_name":"Darth","ambassadorship":null,"account_type":"personal"},"title":null,"tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":1,"like_count":0,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":null,"is_nominated":false,"is_liked":false,"inserted_at":"2017-02-17T02:11:35","in_mission":false,"id":1064,"height":2304,"has_model_property":false,"has_adult_content":false,"handle":"UOSsstMSSxq8AnHHm7wk","gallery_ids":null,"filename":"Nature-Spring-032.jpg","description":null,"comment_count":0},{"width":null,"user_selection":{"license":"editorial","id":"9ca31c99-3e62-4090-840c-b39458ff6a86","has_model_property":false},"user":{"username":"auth0|58c64ba2947960750c25ce8f","profile_image":"gs2Xo4kwSjuTNQMHuIaK","organization":null,"last_name":"Vader","is_followed":false,"is_ambassador":false,"id":434,"first_name":"Darth","ambassadorship":null,"account_type":"personal"},"title":null,"tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":0,"like_count":1,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":null,"is_nominated":false,"is_liked":false,"inserted_at":"2017-04-25T04:10:10","in_mission":false,"id":4108,"height":null,"has_model_property":false,"has_adult_content":false,"handle":"tq1OdOVVTsa0ABHEIFv0","gallery_ids":null,"filename":"temp.obj","description":null,"comment_count":0},{"width":2713,"user_selection":{"license":"editorial","id":"86772193-d459-4eb9-aff0-08168489c8f3","has_model_property":false},"user":{"username":"auth0|590b270c51ad1605c47a7b9b","profile_image":null,"organization":null,"last_name":"Test","is_followed":false,"is_ambassador":true,"id":985,"first_name":"Upload","ambassadorship":"pro","account_type":"personal"},"title":"iStock_84356717_LARGE","tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":0,"like_count":1,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":true,"is_nominated":false,"is_liked":false,"inserted_at":"2017-05-04T15:21:04","in_mission":false,"id":4653,"height":1811,"has_model_property":false,"has_adult_content":false,"handle":"0v9N2qu4Rmebtq4dmHWQ","gallery_ids":null,"filename":"iStock_84356717_LARGE.jpg","description":null,"comment_count":0},{"width":4096,"user_selection":{"license":"editorial","id":"f03af134-a1ff-424b-8f39-8497f80cbe55","has_model_property":false},"user":{"username":"auth0|58c64ba2947960750c25ce8f","profile_image":"gs2Xo4kwSjuTNQMHuIaK","organization":null,"last_name":"Vader","is_followed":false,"is_ambassador":false,"id":434,"first_name":"Darth","ambassadorship":null,"account_type":"personal"},"title":null,"tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":0,"like_count":1,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":null,"is_nominated":false,"is_liked":false,"inserted_at":"2017-03-02T08:40:31","in_mission":false,"id":2227,"height":2304,"has_model_property":false,"has_adult_content":false,"handle":"fLuxAsVoSQKDuk6CNFLt","gallery_ids":null,"filename":"Nature-Spring-032.jpg","description":null,"comment_count":0},{"width":6000,"user_selection":{"license":"editorial","id":"a16b7c8a-a321-43fe-a38f-948ae6207ec4","has_model_property":false},"user":{"username":"auth0|5875e172e8e62d2d9e213000","profile_image":"XdQ5yl7VGXovNMLD1gqZ","organization":null,"last_name":"Nhut Dinh","is_followed":false,"is_ambassador":true,"id":27,"first_name":"Nick","ambassadorship":"maestro","account_type":"personal"},"title":"DSC07075_RT","tags":null,"state":"d","star_count":0,"reject_reason":null,"nomination_count":0,"like_count":1,"license":"editorial","is_starred":false,"is_releasable":false,"is_published":true,"is_nominated":false,"is_liked":false,"inserted_at":"2017-05-05T02:39:19","in_mission":false,"id":4681,"height":4000,"has_model_property":false,"has_adult_content":false,"handle":"EVAscAERRi0FDZv0DiwG","gallery_ids":null,"filename":"DSC07075_RT.jpg","description":null,"comment_count":0}]};
                    //     fileUtils.transforms(response.data.data);
                    //     return response;
                    // }
                }
            },
            'vote': {
                url: pixerfUrl.full + 'api/submissions/:submission_id/votes',
                params: {
                    collusion: localStorageService.get('collusion')
                },
                method: 'POST',
                interceptor: {
                    response: function (response) {
                        return response;
                    }
                }
            },
            'unvote': {
                url: pixerfUrl.full + 'api/submissions/:submission_id/votes',
                params: {
                    collusion: localStorageService.get('collusion')
                },
                method: 'DELETE',
                interceptor: {
                    response: function (response) {
                        return response;
                    }
                }
            },
            'winners': {
                url: pixerfUrl.full + 'api/events/2/winners',
                method: 'GET',
                interceptor: {
                    response: function (response) {
                        fileUtils.transforms(response.data.data);
                        return response;
                    }
                }
            },
            

        });
    }
})();

(function(){
'use strict';
  angular
    .module('pixerf')
    .factory('pixerfApiMailSvc', pixerfApiMailSvc);

    pixerfApiMailSvc.$inject = ['$resource', 'pixerfUrl'];

    function pixerfApiMailSvc ($resource, pixerfUrl){
    	return $resource(pixerfUrl.full + 'api/send_email_verification', {}, {
            'sendReservation': {
                url: pixerfUrl.full + 'api/events/register',
                method: 'POST'

            },

        });
    }
})();

(function () {
    'use strict';
    angular
        .module('pixerf')
        .controller('homePageCtrl', homePageCtrl)

    homePageCtrl.$inject = ['pixerfApiMailSvc', 'toastr', 'messageConst', 'messagePopupSvc', 'pixerfUrl', '$scope', 'systemUtils', '$timeout', '$state', '$rootScope', 'socketSvc'];
    function homePageCtrl(pixerfApiMailSvc, toastr, messageConst, messagePopupSvc, pixerfUrl, $scope, systemUtils, $timeout, $state, $rootScope, socketSvc) {
        var self = this;
        self.CONST_MIN_FILE_SIZE = 5;
        self.onReservationBtnClicked = onReservationBtnClicked;
        self.onSubmissionBtnClicked = onSubmissionBtnClicked;
        self.onVenueClicked = onVenueClicked;
        self.onSubmitNowBtnClicked = onSubmitNowBtnClicked;
        self.navigateTo = navigateTo;
        self.onPhotoGridInit = onPhotoGridInit;
        self.onPhotoGridRenderCompleted = onPhotoGridRenderCompleted;
        self.onSliderInit = onSliderInit;
        self.isVotable = $rootScope.message.votable;
        self.isPublished = $rootScope.message.published;
        var mSlideNamePositionMapping = {
            "rsvp": 1,
            "collusion": 2,
            "submit-submission": 3,
            "video-assets": 4
        };
        self.slideStartPosition = $state.params.slide ? mSlideNamePositionMapping[$state.params.slide] : 0;
        self.videos = [{
            id: "video_" + new Date().getTime(),
            title: 'COLLUSION: Intrigue',
            source: '../assets/video/v04_PIXERF_Collusion_Teaser01_15Jan2018.mp4',
            poster: '../assets/images/video-cover/v04_PIXERF_Collusion_Teaser01_15Jan2018.jpg'
        },{
            id: "video_" + new Date().getTime(),
            title: 'COLLUSION: Exposition',
            source: '../assets/video/v08_PIXERF_COLLUSION_TEASER_02_19JAN2018.mp4',
            poster: '../assets/images/video-cover/v08_PIXERF_COLLUSION_TEASER_02_19JAN2018.jpg'
        },{
            id: "video_" + new Date().getTime(),
            title: 'COLLUSION: Recapitulation',
            source: '../assets/video/v04_PIXERF_COLLUSION_TEASER_03_29JAN2018.mp4',
            poster: '../assets/images/video-cover/v04_PIXERF_COLLUSION_TEASER_03_29JAN2018.jpg'
        },{
            id: "video_" + new Date().getTime(),
            title: 'COLLUSION: Genesis',
            source: '../assets/video/v03_PIXERF_COLLUSION_OPENING_GENESIS_720P_06FEB2018.mp4',
            poster: '../assets/images/video-cover/v03_PIXERF_COLLUSION_OPENING_GENESIS_02FEB2018.jpg'
        },{
            id: "video_" + new Date().getTime(),
            title: 'COLLUSION: Revelations',
            source: '../assets/video/v03_PIXERF_COLLUSION_CLOSING_REVELATION_720P_06FEB2018.mp4',
            poster: '../assets/images/video-cover/v03_PIXERF_COLLUSION_CLOSING_REVELATIONS_02FEB2018.jpg'
        }];
        function onSliderInit(owlInstance){
            self.owlInstance = owlInstance;
            owlInstance.onResize();
            showNavNumberSlide();
        }
        self.dropzone = {
            instance : {},
            options: {
                previewTemplate: document.querySelector('#previews-template').innerHTML,
                autoProcessQueue: false,
                paramName: 'media',
                clickable: [".submission__dropzone", ".slide-submission__change-photo-btn"],
                previewsContainer: '#previews',
                url: pixerfUrl.full + '/api/events/2/submission',
                thumbnailWidth: null,
                method: 'POST',
                maxFiles: 1,
                maxFilesize: 40,
                dictDefaultMessage: '',
                maxThumbnailFilesize: 40,
                acceptedFiles: "image/jpeg",
                dictInvalidFileType: "Sorry, we only accept JPEG file.",
                dictFileTooBig: 'Maximum file size is {{maxFilesize}}MB'
            },
            eventHandlers: {
                success: function(file, response){
                    self.submissionData = {};
                    this.removeAllFiles();
                    $timeout(function(){
                        self.isWorking = false;
                        messagePopupSvc.showPopup({message: messageConst.success.SUBMISSION});
                    },2000);
                    systemUtils.apply($scope);
                },
                addedfile: function(file) {
                    self.isGeneratingThumbnail = true;
                    if(this.files.length > 1){
                        this.removeFile(this.files[0]);
                    }
                    systemUtils.apply($scope);
                      
                },
                uploadprogress: function(file, progress){
                    var roundProgress = Math.round(progress);
                    file.upload.progress = roundProgress;
                    systemUtils.apply($scope);
                },
                sending: function(file, xhr, formData){
                    formData.append("name", self.submissionData.name);
                    formData.append("email", self.submissionData.email);
                    formData.append("title", self.submissionData.title);
                    formData.append("description", self.submissionData.description);
                },
                error: function(file, err){
                    self.isGeneratingThumbnail = false;
                    this.removeAllFiles();
                    self.isWorking = false;
                    toastr.error(err);
                    systemUtils.apply($scope);
                },
                thumbnail: function(file, dataUrl) {
                    if(!validateMinFileSize(file)){
                        this.removeFile(this.files[0]);
                        toastr.error("Minimum file size is 5MP");
                    }
                    self.isGeneratingThumbnail = false;
                    systemUtils.apply($scope);
                }
               
            }
        }
        function onSubmissionBtnClicked(form){
            var errMsg = validateFormSubmission(form);
            if(errMsg){
                toastr.error(errMsg);
                return;
            }
            self.isWorking = true;
            self.dropzone.instance.processQueue();
        }
        self.reservationInfo = {};
        self.submissionData = {}
        

        function showNavNumberSlide(){
            $rootScope.mainOwl.on('initialized.owl.carousel changed.owl.carousel resized.owl.carousel', function(e) {
                owl_carousel_page_numbers(e);
            });
        }
        
        function owl_carousel_page_numbers(e){
            var items_per_page = e.page.size;
            if (items_per_page > 1){
                var min_item_index  = e.item.index,
                max_item_index  = min_item_index + items_per_page,
                display_text    = (min_item_index+1) + '-' + max_item_index;
            } else {
                var display_text = (e.item.index+1);
            }
            $('#numbered-navigation').text( transformNumber(display_text) + ' / ' + transformNumber(e.item.count));
        }
        
        function transformNumber(number){
            if(number < 10){
                return "0" + number;
            }
            return number;
        }
        function validateFormReservation(form){
            form.$setDirty();
            var errMsg = '';
            if(form.name.$error.required){
                errMsg = "Please input your name!";
            } else if(form.email.$error.required){
                errMsg = "Please input your email address!";
            } else if(form.email.$error.email ){
                errMsg = "Invalid email address";
            }
            return errMsg;
        }
        function validateFormSubmission(form){
            form.$setDirty();
            var errMsg = '';
            if(self.dropzone.instance.getAcceptedFiles().length === 0){
                errMsg = "Please choose a photo to submit!";
            } else if(form.name.$error.required){
                errMsg = "Please input your name!";
            } else if(form.email.$error.required){
                errMsg = "Please input your email address!";
            } else if(form.email.$error.email ){
                errMsg = "Invalid email address";
            } else if(form.title.$error.required ){
                errMsg = "Please input photo's title";
            } else if(form.description.$error.required ){
                errMsg = "Please input photo's description";
            }
            return errMsg;
        }
        
        function onReservationBtnClicked(data, form){

            if(self.isWorking) return;
            var errMsg = validateFormReservation(form);
            if(errMsg) {
                toastr.error(errMsg);
                return false;
            }
            self.isWorking = true;
            pixerfApiMailSvc.sendReservation({"registration": data}).$promise.then(function(respone){
                self.reservationInfo = {};
                self.isWorking = false;
                messagePopupSvc.showPopup({message: messageConst.success.RSVP});
            }, function(){
                self.isWorking = false;
                toastr.error(messageConst.error.SOME_THING_WRONG);
            });
        }
        function validateMinFileSize(file){
            return file.width*file.height >= self.CONST_MIN_FILE_SIZE*1000*1000;
        }
        function navigateTo(slideIndex){
            $rootScope.mainOwl.trigger('to.owl.carousel', slideIndex);
        }
        function onVenueClicked(){
            messagePopupSvc.showPopup({htmlTemplate: "app/components/how-to-get-there/how-to-get-there.html", size: 'lg', hideOKBtn: true});
        }
        function onPhotoGridInit(photoGrid){
            self.photoGrid = photoGrid;
            self.photoGrid.fetchPhotos({}, true).then(function(){
            });
        }
        function onPhotoGridRenderCompleted(){
            $timeout(function(){
                self.owlInstance.refresh();
            });
        }
        function onSubmitNowBtnClicked(){
            messagePopupSvc.showPopup({message: messageConst.info.SUBMISSION_CLOSED});
        }


    }
    
})();

// (function() {
//     'use strict';
  
//     angular
//       .module('pixerf')
//       .config(routerConfig);
  
//     routerConfig.$inject = ['$stateProvider'];
  
//     function routerConfig($stateProvider) {
//       'ngInject';
//       $stateProvider
//         .state('home', {
//           url: '/:slide',
//           templateUrl: 'app/home-page/home-page.html',
//           controller: 'homePageCtrl',
//           controllerAs: 'vm',
//           data: {
//           }
//         });
//     }
  
//   })();
  
(function () {
    'use strict';
    angular
        .module('pixerf')
        .constant('fileConst', function () {
            var conObj = {
                PATH: {
                    UNSAFE: "http://52.76.226.116/unsafe/",
                    FILESTACK: "https://process.filestackapi.com/"
                },
                FILESTACK_CONTAINER: {
                    USER_PROFILE: "pixerf-filepicker-profile",
                    USER_COVER: "pixerf-filepicker-cover",
                },
                SIZE_DEFINITION: [
                    { name: "SMALL", value: 1 },
                    { name: "MEDIUM", value: 3 },
                    { name: "LARGE", value: 4 },
                    { name: "X-LARGE", value: 12 },
                    { name: "XX-LARGE", value: 24 }
                ],
                FILE_STATE_NAME: {
                    'TRENDING': 'trending',
                    'GENERAL': 'general',
                    'REJECTED': 'rejected',
                    'PENDING': 'pending',
                    'DISCOVER': 'discover',
                    'EDITOR_PICK': "editor's-pick"
                },
                BADGES: {
                    CODES: {
                        MISSION_WINNER: "M",
                        MISSION_CONSOLATION: "MC",
                        EDITOR_PICK: "PC"
                    }
                },
                UPLOAD_PHOTO_VALIDATION: {
                    ERROR_CODE: {
                        FAILED_TO_UPLOAD: "FAILED_TO_UPLOAD",
                        INVALID_FILETYPE: "UPLOAD_VALIDATION_INVALID_FILETYPE",
                        DUPLICATED: "UPLOAD_VALIDATION_DUPLICATED",
                        INVALID_MIN_RESOLUTION: "UPLOAD_VALIDATION_INVALID_MIN_RESOLUTION",
                        INVALID_MIN_INSPIRATION_RESOLUTION: "INVALID_MIN_INSPIRATION_RESOLUTION",
                        INVALID_MAX_INSPIRATION_RESOLUTION: "INVALID_MAX_INSPIRATION_RESOLUTION",
                        INVALID_MAX_FILESIZE: "UPLOAD_VALIDATION_INVALID_MAX_FILESIZE",
                        EXCEED_NUMBER_OF_UPLOAD_PER_WEEK: "EXCEED_NUMBER_OF_UPLOAD_PER_WEEK",
                        EXCEED_NUMBER_OF_UPLOAD_PER_MISSION: "EXCEED_NUMBER_OF_UPLOAD_PER_MISSION",
                        EXCEED_NUMBER_OF_INSPIRATION_UPLOAD_PER_MISSION: "EXCEED_NUMBER_OF_INSPIRATION_UPLOAD_PER_MISSION"
                    },
                    PHOTO_SIZE: {
                        MIN_RESOLUTION: 5,
                        MIN_INSPIRATION_RESOLUTION: 0.5,
                        MAX_INSPIRATION_RESOLUTION: 4,
                        MAX_FILE_SIZE: 40
                    },
                    MISSION_LIMIT: 6,
                    MISSION_INSPIRATIONLIMIT: 15,
                },
                PHOTO_GRID_PAGE_SIZE: 17
            };
            conObj.FILE_STATE_DEFINITION = function () {
                var obj = {};
                for (var key in conObj.FILE_STATE_NAME) {
                    if (key === 'PENDING') {
                        obj[conObj.FILE_STATE_NAME[key]] = 'h';
                    } else {
                        obj[conObj.FILE_STATE_NAME[key]] = conObj.FILE_STATE_NAME[key][0].toLowerCase();
                    }
                }
                return obj;
            }();
            return conObj;
        }());
})();
(function() {
    'use strict';
    angular
        .module('pixerf')
        .constant('commonConst', {
            ACTION: {
                CREATE: "CREATE",
                EDIT: "EDIT",
                DELETE: "DELETE"
			},
			SCREEN:{
				MOBILE: 1023
			}
        });
})();
function PixerfEnv(){
    this.ENV = {
        PRODUCTION : "PRODUCTION",
        STAGING: "STAGING",
        TESTING: "TESTING",
        DEVELOPING: "DEVELOPING"
    }
    
    
}
PixerfEnv.prototype = (function(){
    function getEnv(){
        var URL_PRFIX = "https://";
        if (!String.prototype.startsWith) {
            String.prototype.startsWith = function(searchString, position) {
                position = position || 0;
                return this.indexOf(searchString, position) === position;
            };
        }
        if(location.href.startsWith(URL_PRFIX + "collusion.pixerf.com")){
            return this.ENV.PRODUCTION;
        }
        else if (location.href.startsWith(URL_PRFIX + 'staging.pixerf.com')){
            return this.ENV.STAGING;
        }
        else if (location.href.startsWith(URL_PRFIX + 'qa.pixerf.com')){
            return this.ENV.TESTING;
        }
        return this.ENV.TESTING;
    }
    return {
        getEnv: getEnv
    }
})();
function PixerfAuth0Configurer(){
    this.ENV = {
        "PRODUCTION": {
            clientID: "CX71vZ6A5B2CRUWycgcwSjqRJomeQL1n",
            domain: "pixerf.au.auth0.com"
        },
        "STAGING": {
            clientID: "Qtn7RYBZ4tpP35pXDBj9PR0zYIEDPv4N",
            domain: "pixerf-staging.au.auth0.com"
        },
        "TESTING": {
            clientID: "d5Ehkv7aRKGthnC6l8AgHZmU2GaNK7K4",
            domain: "pixerf-qa.au.auth0.com"
        },
        "DEVELOPING": {
            clientID: "d5Ehkv7aRKGthnC6l8AgHZmU2GaNK7K4",
            domain: "pixerf-qa.au.auth0.com"
        }
    }
}
PixerfAuth0Configurer.prototype = (function(){
    function getEnv(){
        var pixerfEnv = new PixerfEnv();
        return this.ENV[pixerfEnv.getEnv()];
    }
    return {
        getEnv: getEnv
    }
})();
function PixerfAPIUrlConfigurer(){
    this.URL_PRFIX = "https://";
    this.URL_AFFIX = "/";
    this.ENV = {
        DEVELOPING: "phoenix.pixerf.com",
        PRODUCTION : "pixerf.com",
        STAGING: "staging.pixerf.com",
        TESTING: "qa.pixerf.com"
    }
}
PixerfAPIUrlConfigurer.prototype = (function(){
    function getBaseUrl(){
        var pixerfEnv = new PixerfEnv();
        return this.ENV[pixerfEnv.getEnv()];
    }
    return {
        getBaseUrl: getBaseUrl
    }
})();
(function () {
    angular.module('pixerf')
        .directive('videoBg', videoBg);
    videoBg.$inject = ['$timeout', 'responsiveUtils']
    function videoBg($timeout, responsiveUtils) {
        function playVideo(video){
            $timeout(function(){
                window.intervalId =  setInterval(function(){
                    console.log(video.readyState);
                    if(video.readyState === 4){
                        video.play();
                        clearInterval(window.intervalId);
                    }
                },1000)
            },0);
        }
        function getVideoSource(){
            var videoSrc = '../assets/video/v05_PIXERF_Collusion_Microsite_Landscape_05Jan2018.mp4';
            if(responsiveUtils.isPortrait()){
                videoSrc = '../assets/video/v04_PIXERF_Collusion_Microsite_Portrait_05Jan2018.mp4';
            }
            return videoSrc;
        }
        function getVideoPoster(){
            var posterSrc = '../assets/images/video-cover/v05_PIXERF_Collusion_Microsite_Landscape_05Jan2018.jpg';
            if(responsiveUtils.isPortrait()){
                posterSrc = '../assets/images/video-cover/v04_PIXERF_Collusion_Microsite_Portrait_05Jan2018.jpg';
            }
            return posterSrc;
        }
        function setSize($video){
            var $window = $(window);
            if($window.width()/$window.height() >= 16/9 || responsiveUtils.isPortrait()){

                $video.width("100%");
                $video.height("auto");
            }
            else {
                $video.width("auto");
                $video.height("100%");
            }
        }
        function setVideo($video){
            var videoSrc = getVideoSource();
            var posterSrc = getVideoPoster();
            $video.attr("src", videoSrc);
            $video.attr("poster", posterSrc);
        }
        function orientationHandler($video){
            setVideo($video);
            var video = $video.get(0);
            playVideo(video);
        }
        return {
            scope: {},
            restrict: 'A',
            replace: true,
            link: function (scope, element) {
                var $video = $("<video autoplay loop  muted playsinline></video");
                setVideo($video);
                $(element).append($video.get(0));
                setSize($video);
                var video = $video.get(0);
                playVideo(video);

                var eventName =  "resize." + new Date().getTime();
                var $window = $(window);
                $(window).on(eventName, _.debounce(onResize,300));

                function onResize(event){
                    console.log(scope.width);
                    // uncomment for only fire when $window.innerWidth change   
                    if (scope.width !== $window.innerWidth()){
                        scope.width = $window.innerWidth();
                        orientationHandler($video);
                        setSize($video);
                    }
                }
                function cleanUp() {
                    $window.off(eventName, onResize);
                }
                
                scope.$on('$destroy', cleanUp);

            }
        }
    }
})();
(function () {
    angular.module('pixerf')
        .directive('resizeWidthEvent', resizeWidthEvent);
    resizeWidthEvent.$inject = ['$timeout', 'responsiveUtils']
    function resizeWidthEvent($timeout, responsiveUtils) {
        return {
            restrict: 'A',
            link: function (scope, element,attrs) {
                

                var eventName =  "resize." + new Date().getTime();

                $(window).on(eventName, onResize);

                function onResize(event){
                    // uncomment for only fire when $window.innerWidth change   
                    if (scope.width !== window.innerWidth){
                        scope.width = window.innerWidth;
                        scope.$apply(function (){
                            scope.$eval(attrs.resizeWidthEvent);
                        });
                    }
                }
                function cleanUp() {
                    $(window).off(eventName, scope.onResize);
                }
                
                scope.$on('$destroy', cleanUp);
            }
            
        }
    }
})();
(function() {
    'use strict';

    // TODO: replace this with uday's

    angular
        .module('pixerf')
        .directive('pixerfDropzone', pixerfDropzone);

        pixerfDropzone.$inject = ['$rootScope'];

    function pixerfDropzone($rootScope) {
        return {
            scope: {
                pixerfDropzone: '='
            },
            restrict: 'A',
            link: function(scope, element, attrs) {
                try { Dropzone } catch (error) {
                    throw new Error('Dropzone.js not loaded.');
                }

                scope.pixerfDropzone.instance = new Dropzone(element[0], scope.pixerfDropzone.options);

                if (scope.pixerfDropzone.eventHandlers) {
                    Object.keys(scope.pixerfDropzone.eventHandlers).forEach(function(eventName) {
                        scope.pixerfDropzone.instance.on(eventName, scope.pixerfDropzone.eventHandlers[eventName]);
                    });
                }
                var $element = $(element);
            }
        }
    }

})();

(function () {
    angular.module('pixerf')
        .directive('owlSlider', owlSlider);
        owlSlider.$inject = ['$rootScope', 'systemUtils'];
    function owlSlider($rootScope, systemUtils) {
        return {
            scope: {
                owlSliderStartPosition: "=",
                onSliderInit: '&?'
            },
            restrict: 'A',
            link: function (scope, element) {
                setTimeout(function(){
                    var $element = $(element);
                    $rootScope.mainOwl =  $element.owlCarousel({
                        autoPlay: true,
                        navigation: false,
                        pagination: true,
                        transitionStyle: "fade", // fade, backSlide, goDown, fadeUp
                        singleItem: true,
                        items: 1,
                        autoHeight: true,
                        stopOnHover: false,
                        nav: true,
                        URLhashListener:true,
                        startPosition: 'URLHash',
                        navText: ["<div class='icon-arrow_left'></div>","<div class='icon-arrow_right'></div>"]
                    });
                    $element.on("translated.owl.carousel", function(event){
                        systemUtils.scrollTo();
                    })
    
                    var owl = $(element).data('owl.carousel');
    
                    scope.onSliderInit({owlInstance: owl});
                })

            }
        }
    }
})();

(function () {
    angular.module('pixerf')
        .directive('loadingBtn', loadingBtn);
    function loadingBtn() {
        return {
            scope: {},
            restrict: 'E',
            link: function (scope, element) {
                
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('imageLoad', imageLoad);
    imageLoad.$inject = ['$parse', '$window'];

    function imageLoad($parse, $window) {
        return function(scope, element, attrs) {
            setTimeout(function(){
                var $element = $(element);
                var $img = $element;
                var $overlay = $element.find("+ .image-overlay");
    
                $img.on('bestfit', function() {
                    $overlay.width($img.width());
                    $overlay.height($img.height());
                }).on('load', function() {
                    $(this).trigger('bestfit');
                    console.log($(this).width());
                }).trigger('bestfit');
                angular.element($window).on('resize', function(){
                    $overlay.width($img.width());
                    $overlay.height($img.height());
                })
            },100)
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('indexCtrl', indexCtrl);

    indexCtrl.$inject = [];

    function indexCtrl() {
        var self = this;
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .run(runBlock);

  runBlock.$inject = ['$rootScope', 'socketSvc', 'systemUtils', 'fileUtils', '$route', 'winnersListSvc'];

  function runBlock($rootScope, socketSvc, systemUtils, fileUtils, $route, winnersListSvc) {
    $rootScope.message = {
      votable: {
        data: true
      },
      published: {
        data: false
      },
      winners: {
        data: []
      }
    }
    socketSvc.joinPublicChannel();
    $rootScope.message.votable.data = false;
    $rootScope.message.published.data = true;
    winnersListSvc.getWinners().then(function(winners){
      $rootScope.message.winners.data = winners;
      // $rootScope.message.votable.data = !$rootScope.message.winners.data || ($rootScope.message.winners.data && $rootScope.message.winners.data.length === 0);
      // $rootScope.message.published.data =  $rootScope.message.winners.data && $rootScope.message.winners.data.length > 0;
      // if(winners.length === 0){
        setTimeout(function(){
          socketSvc.subscribeTopic(socketSvc.PIXERF_TOPICS.COLLUSION.name.toUpperCase(), function(message){
            // console.log(message);
            // $rootScope.message.published.data = message.published;
            // $rootScope.message.winners.data = fileUtils.transforms(message.winners);
            // $rootScope.message.votable.data = message.votable;
            // systemUtils.apply($rootScope);
            // $route.reload();
            ///
            location.reload();
          })
        }, 3000);
      // }
    })


  }
})();

(function() {
  'use strict';

  angular
    .module('pixerf')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider', '$urlRouterProvider'];

  function routerConfig($stateProvider, $urlRouterProvider) {
    'ngInject';
    $urlRouterProvider.when('', '/');
  }

})();

// /* global malarkey:false, moment:false */
// (function() {
//   'use strict';

//   angular
//     .module('pixerf')
//     .constant('moment', moment);

// })();

(function () {
  'use strict';
  angular
    .module('pixerf')
    .config(config)
    .provider('pixerfUrl', function () {

      var pixerfAPIUrlConfigurer = new PixerfAPIUrlConfigurer(); 
      var baseUrl = pixerfAPIUrlConfigurer.getBaseUrl();

      this.$get = function () {
        return {
          full: pixerfAPIUrlConfigurer.URL_PRFIX + baseUrl + pixerfAPIUrlConfigurer.URL_AFFIX,
          domainOnly: baseUrl
        }
      }

    });
  config.$inject = ['toastrConfig', '$httpProvider'];
   function config(toastrConfig, $httpProvider) {
    $httpProvider.defaults.withCredentials = true;
    toastrConfig.maxOpened = 1;
    toastrConfig.autoDismiss = true;
    toastrConfig.allowHtml = true;
    toastrConfig.extendedTimeOut = 15000;
    toastrConfig.closeButton = true;
    toastrConfig.positionClass = 'toast-top-center';
    toastrConfig.toastClass = 'pixerf-alert-message';

  }

})();

angular.module("pixerf").run(["$templateCache", function($templateCache) {$templateCache.put("app/home-page/home-page.html","<div class=home-page ng-controller=\"homePageCtrl as vm\"><div class=\"owl-carousel owl-theme slides\" owl-slider owl-slider-start-position=vm.slideStartPosition on-slider-init=vm.onSliderInit(owlInstance)><div class=\"front-slide slide\" data-hash=/ ><div video-bg></div></div><!-- <div class=\"slide slide-rsvp\" data-hash=\"/rsvp\">\r\n            <div class=\"slide-content-box clearfix\">\r\n                <div class=\"slide-content\">\r\n                    <div class=\"rsvp-title\">RSVP</div>\r\n                    <div class=\"rsvp-showcase\">We want you at <span class=\"animation\">COLLUSION</span>, a one-night event where you can mingle with the most influential and proliﬁc <span class=\"animation\">photographers</span> in the industry, try your hand at one of the hottest photography trends, and meet an eclectic community of <span class=\"animation\">passionate creatives</span> just like yourself.</div>\r\n                    <div class=\"rsvp-event\">\r\n                        <div class=\"rsvp-date\">02.02.2018</div>\r\n                        <div class=\"rsvp-time\">5.30pm &ndash; 8.30pm</div>\r\n                        <div class=\"rsvp-location\">\r\n                            <div class=\"rsvp-location__label text--theme\">Venue: Funan Showsuite</div>\r\n                            <div class=\"rsvp-location__guide-text\">Click <span class=\"text--theme cusor--pointer\" ng-click=\"vm.onVenueClicked()\" title=\"How to get there\">here</span> for directions</div>\r\n                        </div>\r\n                    </div>\r\n                    <form name=\"guestInfo\" class=\"guest-info-form\">\r\n                        <div class=\"rsvp-guest-info\">\r\n                            <div class=\"rsvp-guest-fill rsvp-guest-name\"><input required ng-model=\"vm.reservationInfo.name\" name=\"name\" type=\"text\" placeholder=\"Name\" /></div>\r\n                            <div class=\"rsvp-guest-fill rsvp-guest-address\"><input required ng-model=\"vm.reservationInfo.email\" name=\"email\" type=\"email\"  placeholder=\"Email\" /></div>\r\n                            <div class=\"rsvp-guest-fill rsvp-guest-contact\"><input ng-model=\"vm.reservationInfo.contact\" type=\"text\" value=\"\" placeholder=\"Contact (optional)\" /></div>\r\n                            <div class=\"rsvp-guest-fill rsvp-guest-who-tell-you\"><input ng-model=\"vm.reservationInfo.feedback\" type=\"text\" value=\"\" placeholder=\"Who did you hear about COLLUSION from?\"/></div>\r\n                        </div>\r\n                        <button ng-click=\"vm.onReservationBtnClicked(vm.reservationInfo, guestInfo)\" class=\"rsvp-signup-event-btn pixerf-btn\"><span  data-text=\"Sign me up for COLLUSION\">Sign me up for COLLUSION</span></button>\r\n                    </form>\r\n                    <div class=\"rsvp-note\">Check back to this site as more will be revealed closer to the date. </div>\r\n                </div>\r\n            </div>\r\n        </div> --><div class=\"slide slide-collusion\" data-hash=/collusion><div class=\"slide-content-box clearfix\"><div class=slide-content><div class=collusion-title>COLLUSION</div><div class=\"collusion-showcase-box clearfix\"><div class=collusion-showcase-paragraph>It is more than meets the eye, hovering on the shadow\'s edge, a trick of light. A secret understanding.</div><div class=\"collusion-showcase-paragraph paragraph-max-width-custom-1\">It is the coming together of distant stars, causing a chain reaction that will create new worlds, new life. The big bang.</div><div class=collusion-showcase-paragraph>It is a quiet alliance, breaking the constraints of old to pave the way for new. Forward-looking, onward-marching, visionary. The revolution of photography with a truly Asian perspective.</div><div class=\"collusion-showcase-paragraph paragraph-max-width-custom-2\">Partnership, vision, and secrecy for a greater mission – <span class=animation>Collusion</span> is all these and more.</div><div class=collusion-showcase-text>THIS IS YOUR MISSION</div><div class=collusion-showcase-paragraph>Show us how you define <span class=animation>Collusion</span> in one visually stunning and provocative photo and stand to <span class=animation>win over $3,000 </span>in prizes.</div><div class=\"collusion-showcase-paragraph paragraph-max-width-custom-3\">You could use a perspective-warping angle to create multiple images in one; capture a mood rich with emotional elements; or create a conceptual shot with deep storytelling quality.</div><div class=\"collusion-showcase-paragraph paragraph-max-width-custom-3\">Show us your vision of <span class=animation>Collusion</span>, and we\'ll help you tell its story to the world.</div></div><button ng-click=vm.onSubmitNowBtnClicked() class=\"collusion-join-btn pixerf-btn\"><span data-text=\"Submit now\">Submit now</span></button></div></div></div><div class=\"slide slide-submission\" data-hash=/submit-mission ng-if=!vm.isPublished.data><div class=\"slide-content-box clearfix\"><div class=\"slide-content ng-hide\"><div class=submission-title>Submit your COLLUSION photo</div><div class=\"submission-showcase-box clearfix\"><div class=submission-showcase-paragraph>By <span class=\"deadline-submission text--bold\">24 January 2018</span> with the following criteria:</div><ul class=submission-criteria><li class=submission-criteria__item>Only 1 submission per person</li><li class=submission-criteria__item>JPEG format</li><li class=submission-criteria__item>Minimum {{vm.CONST_MIN_FILE_SIZE}} megapixels and up to 40MB in size</li><li class=submission-criteria__item>No nudity, violence, or illegal substances allowed</li><li class=submission-criteria__item>All submissions will be reviewed by the PIXERF curation team</li><li class=submission-criteria__item>Submissions containing inappropriate content may be disqualified</li><li class=submission-criteria__item>All fields below are mandatory</li></ul><div class=submission__attach-photo><div class=\"submission__attach-photo__frame-middle submission__dropzone\" pixerf-dropzone=vm.dropzone><div ng-show=\"vm.dropzone.instance.files.length === 0\" class=dz-message><div class=\"submission__attach-photo__icon icon-attach_photo\"></div><div class=\"submission__attach-photo__label pixerf-btn\">Attach photo</div></div><div ng-show=vm.isGeneratingThumbnail class=vertical-align-middle><i class=\"fa fa-spinner fa-spin fa-3x fa-fw text--theme\"></i></div><div id=previews></div></div><div ng-class=\"{\'slide-submission__change-photo-btn--show\': vm.dropzone.instance.files.length > 0}\" class=\"text--bold text--white slide-submission__change-photo-btn cusor--pointer pixerf-link pixerf-link--white pixerf-btn\">Change photo</div></div><form name=submissionForm class=submission-form><div class=\"submission-info clearfix\"><div class=\"submission-field submission__name\"><input required name=name type=text placeholder=Name ng-model=vm.submissionData.name></div><div class=\"submission-field submission__email\"><input required name=email type=email placeholder=Email ng-model=vm.submissionData.email></div><div class=\"submission-field submission__photo-title\"><input required name=title type=text placeholder=\"Photo title\" ng-model=vm.submissionData.title></div><div class=\"submission-field submission__photo-description\"><input required type=text name=description placeholder=\"Photo description\" ng-model=vm.submissionData.description></div></div><button ng-click=vm.onSubmissionBtnClicked(submissionForm) class=\"submission__submit-btn pixerf-btn\"><span data-text=Submit>Submit</span></button></form></div></div><div class=slide-content><div class=submission-title>Who will win the<br>COLLUSION Mission?</div><div class=\"submission-showcase-box clearfix\"><div class=submission-showcase-paragraph><p>The submissions are in, and it’s time to select the most stunning photos that define COLLUSION</p><p>Vote for your top three favourites wisely – they stand to win over $3,000 in prizes!</p></div><div class=slide-submission__prizes><div class=\"slide-submission__prize slide-submission__prize--winner\"><h3 class=\"text--theme slide-submission__prize__prize-title\">Winner</h3><p class=slide-submission__prize__prize-detail>Profoto A1</p><p class=slide-submission__prize__prize-sub-detail>(worth up to $1,500)</p></div><div class=clearfix><div class=\"col-md-6 slide-submission__prize slide-submission__prize--2nd\"><h4 class=\"text--theme slide-submission__prize__prize-title\">First Runner-up:</h4><p class=slide-submission__prize__prize-detail>Datacolor Spyder5STUDIO and Manfrotto Street Camera Sling/Waist Pack</p><p class=slide-submission__prize__prize-sub-detail>(worth up to $950)</p></div><div class=\"col-md-6 slide-submission__prize col-md-6 slide-submission__prize--3rd\"><h4 class=\"text--theme slide-submission__prize__prize-title\">Second Runner-up:</h4><p class=slide-submission__prize__prize-detail>Full-day usage of Raw. Studio, inclusive of a half-day session with Alexander Ow, Lead Photographer and Curator at PIXERF</p><p class=slide-submission__prize__prize-sub-detail>(worth up to $600)</p></div></div></div><button ng-click=vm.navigateTo(3) class=\"pixerf-btn--submit-btn submission__go-to-vote-btn\"><span data-text=Submit>Cast your votes now</span></button><p class=text--white>Voting closes 2 February 2018, at 5pm.</p></div></div></div></div><div class=\"slide slide-voting\" data-hash=/voting><div class=\"slide-content-box clearfix\"><div class=slide-content><div class=slide-content__slide-title>{{vm.isVotable.data ? \'Which three photos will get your vote?\' : \'Here are the submissions to the COLLUSION Mission!\'}}</div><div class=slide-content__main-content><photo-grid options=\"{isDisableVote: !vm.isVotable.data}\" on-render-completed=vm.onPhotoGridRenderCompleted() on-init=vm.onPhotoGridInit(photoGrid) hide-no-more-message=true><div class=\"text-center marketplace__no-result-message\"><span class=icon-icons_search></span><h3 class=\"text-semibold no-message-notice text--semibold text--color-black\">No photos found</h3></div></photo-grid></div></div></div></div><div id=slide-voting-result ng-if=vm.isPublished.data><div class=\"slide slide-voting-result\" data-hash=/voting-result><div class=\"slide-content-box clearfix\"><div class=slide-content><div class=slide-content__slide-title>COLLUSION Mission Winners</div><div class=slide-content__main-content><div><winners-list></winners-list></div></div></div></div></div></div><div class=\"slide slide-in-collusion\" data-hash=/in-collusion><div class=\"slide-content-box clearfix\"><div class=slide-content><div class=in-collusion-title>In COLLUSION</div><div class=\"in-collusion-showcase-box clearfix\"><div class=\"top-notch-sponsor clearfix\"><div class=\"text--theme sponsor-title\">With top-notch lighting from</div><div class=\"sponsor-logo profoto-logo\"><img src=../assets/images/sponsors/profoto.png alt=PROFOTO></div><div class=\"sponsor-logo srishti-logo\"><img src=../assets/images/sponsors/srishti.png alt=SRISHTI></div></div><div class=\"heaps-sponsor clearfix\"><div class=\"text--theme sponsor-title\">And heaps of support from</div><div class=\"sponsor-logo cathay-logo\"><img src=../assets/images/sponsors/cathay.png alt=\"CATHAY PHOTO\"></div><div class=\"sponsor-logo raw-logo\"><img src=../assets/images/sponsors/raw.png alt=RAW></div><div class=\"sponsor-logo gravitate-logo\"><img src=../assets/images/sponsors/gravitate.png alt=GRAVITATE></div></div><div class=\"serving-happening-sponsor clearfix\"><div class=\"serving-sponsor clearfix\"><div class=\"text--theme sponsor-title\">Serving you the good times</div><div class=\"sponsor-logo crossroads-logo\"><img src=../assets/images/sponsors/cross-road.png alt=CROSSROADS></div></div><div class=\"happening-sponsor clearfix\"><div class=\"text--theme sponsor-title\">All happening at</div><div class=\"sponsor-logo funan-logo\"><img src=../assets/images/sponsors/funan.png alt=FUNAN></div></div></div></div></div></div></div><div class=\"slide slide-videos\" data-hash=/videos><div class=\"slide-content-box clearfix\"><div class=slide-content><div class=slide-videos__slide-title>Videos</div><div class=\"slide-content__main-content clearfix\"><videos-popup videos=vm.videos></videos-popup></div></div></div></div></div><div id=numbered-navigation></div><div id=previews-template class=ng-hide><div class=\"dz-preview dz-file-preview\"><div class=dz-details><img data-dz-thumbnail></div><div class=dz-progress><span class=dz-upload data-dz-uploadprogress></span></div></div></div><progress-circle ng-if=vm.isWorking progress=vm.dropzone.instance.files[0].upload.progress></progress-circle></div>");
$templateCache.put("app/components/footer/footer.html","<div class=microsite-footer><div class=\"pull-left company-reserved\">© 2018 PIXERF Pte Ltd. All Rights Reserved.</div><div class=\"pull-right clearfix social-items\"><a class=social-item href=https://www.facebook.com/Pixerf target=_blank><span class=icon-icons_facebook></span> </a><a class=social-item href=http://instagram.com/Pixerf target=_blank><span class=icon-icons_instagram></span> </a><a class=\"social-item social-last-item\" href=https://twitter.com/Pixerf target=_blank><span class=\"fa fa-twitter\"></span></a></div></div>");
$templateCache.put("app/components/how-to-get-there/how-to-get-there.html","<div class=how-to-get-there><h4 class=how-to-get-there__heading>Getting here</h4><div class=\"how-to-get-there__options clearfix\"><div class=\"col-md-4 how-to-get-there__option\"><div class=\"icon-car how-to-get-there__option__icon\"></div><div class=\"how-to-get-there__option__name text--theme\">By car</div><div class=how-to-get-there__option__detail><div class=how-to-get-there__option__detail__sub-option><div class=how-to-get-there__option__detail__sub-option__name><div class=how-to-get-there__option__detail__sub-option__name__title>High Street Centre</div><div class=how-to-get-there__option__detail__sub-option__name__info>(3 minutes walk)</div></div><div class=how-to-get-there__option__detail__sub-option__detail>There is no parking available for visitors at the showsuite, please make your way to nearby carparks.</div></div></div></div><div class=\"col-md-4 how-to-get-there__option\"><div class=\"icon-bus how-to-get-there__option__icon\"></div><div class=\"how-to-get-there__option__name text--theme\">By bus</div><div class=how-to-get-there__option__detail><div class=how-to-get-there__option__detail__sub-option><div class=how-to-get-there__option__detail__sub-option__name><div class=how-to-get-there__option__detail__sub-option__name__title>High Street Centre</div><div class=how-to-get-there__option__detail__sub-option__name__info><span class=how-to-get-there__option__detail__sub-option__name__info--highlighted>Stop ID: 04229</span><br>2, 12, 33, 147, 190</div></div></div><div class=how-to-get-there__option__detail__sub-option><div class=how-to-get-there__option__detail__sub-option__name><div class=how-to-get-there__option__detail__sub-option__name__title>Old Hill Street Police Centre</div><div class=how-to-get-there__option__detail__sub-option__name__info><span class=how-to-get-there__option__detail__sub-option__name__info--highlighted>Stop ID: 04223</span><br>124, 145, 147, 166, 174, 190, 851</div></div></div><div class=how-to-get-there__option__detail__sub-option><div class=how-to-get-there__option__detail__sub-option__name><div class=how-to-get-there__option__detail__sub-option__name__title>Opp The Treasury</div><div class=how-to-get-there__option__detail__sub-option__name__info><span class=how-to-get-there__option__detail__sub-option__name__info--highlighted>Stop ID: 04249</span><br>51, 61, 63, 80, 124, 145, 166 174, 197, 851, 961</div></div></div></div></div><div class=\"col-md-4 how-to-get-there__option\"><div class=\"icon-train how-to-get-there__option__icon\"></div><div class=\"how-to-get-there__option__name text--theme\">By train</div><div class=how-to-get-there__option__detail><div class=how-to-get-there__option__detail__sub-option><div class=how-to-get-there__option__detail__sub-option__name><div class=how-to-get-there__option__detail__sub-option__name__title>Clarke Quay MRT</div><div class=how-to-get-there__option__detail__sub-option__name__info>(5 minutes walk)</div></div><div class=how-to-get-there__option__detail__sub-option__name><div class=how-to-get-there__option__detail__sub-option__name__title>CityHall MRT</div><div class=how-to-get-there__option__detail__sub-option__name__info>(8 minutes walk)</div></div></div></div></div></div></div>");
$templateCache.put("app/components/message-popup/message-popup.html","<div class=thanks-popup><div ng-click=vm.closePopup() class=\"popup-close-btn cusor--pointer\"><span class=popup-close-btn__text>CLOSE</span> <span class=icon-close></span></div><div class=modal-info><div class=\"modal-body text-center\"><div class=content-wrapper><div ng-if=vm.data.htmlTemplate class=thanks-message ng-include=vm.data.htmlTemplate></div><div ng-if=!vm.data.htmlTemplate class=thanks-message ng-bind-html=vm.data.message></div><button ng-if=!vm.data.hideOKBtn class=\"close-popup-btn pixerf-btn--hover--filled--theme\" ng-click=vm.closePopup()>OK</button></div></div></div></div>");
$templateCache.put("app/components/photo/photo-mobile.html","<div class=photo ng-attr-data-photo-id=file.id><div ng-style=\"{width: file.mobileWidth + \'px\', height: file.mobileHeight + \'px\'}\" ng-click=vm.onPhotoClicked(file)><img ng-src={{file[vm.displaySize]}}></div><div class=\"photo__info clearfix\"><div class=\"photo__info__title text--truncate\">{{file.title}}</div><vote-btn ng-if=!options.isDisableVote photo=file></vote-btn></div></div>");
$templateCache.put("app/components/photo/photo.html","<div ng-click=vm.onPhotoClicked(file) ng-style=\"{\'background-image\': \'url(\' + file[vm.displaySize] + \')\'}\" class=\"photo cusor--zoom\" ng-attr-data-photo-id=file.id><div class=\"overlay overlay--black\"></div><div class=\"photo__info vertical-align-middle\"><div class=\"photo__info__title text--uppercase text--truncate\">{{file.title}}</div><vote-btn ng-if=!options.isDisableVoting photo=file></vote-btn></div></div>");
$templateCache.put("app/components/main-nav/main-nav.html","<div class=\"main-navigation navbar navbar-default\"><button type=button class=navbar-toggle ng-click=vm.toggleMenu() ng-class=\"{\'active\': vm.isBtnToggleActive}\"><div class=main-navigation__collapse-text>{{vm.collapseText}}</div><div class=main-navigation__collapse-btn><span class=\"icon-bar one\"></span> <span class=\"icon-bar two\"></span> <span class=\"icon-bar three\"></span></div></button><div id=microsite-main-menu><div class=main-nav-items><div class=main-nav-item ng-click=vm.goSlide(0)>Home</div><!-- <div class=\"main-nav-item\" ng-click=\"vm.goSlide(1)\">RSVP</div> --><div class=main-nav-item ng-click=vm.goSlide(1)>Your Mission</div><div class=main-nav-item ng-click=vm.goSlide(2)>{{vm.isPublished.data ? \'COLLUSION Submissions\' : \'Submit your COLLUSION photo\'}}</div><div class=main-nav-item ng-click=vm.goSlide(3)>{{vm.isPublished.data ? \'COLLUSION Mission Winners\': \'Cast your votes\'}}</div><div class=main-nav-item ng-click=vm.goSlide(4)>In COLLUSION</div><div class=main-nav-item ng-click=vm.goSlide(5)>Videos</div></div><div class=navigation-footer><div class=navigation-connect><div class=connect-footer-text>Connect with us on</div><div class=connect-icons><a href=https://www.facebook.com/Pixerf target=_blank><div class=\"connect-icon icon-icons_facebook\"></div></a><a href=http://instagram.com/Pixerf target=_blank><div class=\"connect-icon icon-icons_instagram\"></div></a><a href=https://twitter.com/Pixerf target=_blank><div class=\"connect-icon fa fa-twitter\"></div></a></div></div><div class=footer-note>© 2018 PIXERF Pte Ltd. All Rights Reserved.</div></div></div></div>");
$templateCache.put("app/components/photo-detail-popup/photo-detail-popup.html","<div class=photo-detail-popup><div ng-click=vm.closePopup() class=\"popup-close-btn cusor--pointer\"><span class=popup-close-btn__text>CLOSE</span> <span class=icon-close></span></div><div class=modal-info><div class=\"modal-body text-center\"><div class=content-wrapper><pixerf-photo-swipe photos=vm.popupData.photos start-index=vm.popupData.index options=vm.popupData.photoSwipeOptions></pixerf-photo-swipe></div></div></div></div>");
$templateCache.put("app/components/photo-grid/photo-grid.html","<div class=photo-grid resize-width-event=vm.onWindowResize() ng-class=\"{\'photo-grid--fresh\': vm.isFresh && vm.spinner.isVisible}\"><div infinite-scroll-distance=0.5 class=\"clearfix photo-grid__photos-container\" infinite-scroll-disabled=vm.isNoMorePhotoToLoad infinite-scroll=vm.fetchMorePhotos() infinite-scroll-immediate-check=false infinite-scroll-container=vm.containerClass></div><ng-transclude class=ng-hide ng-hide=\"vm.photos.length > 0 || vm.spinner.isVisible\"></ng-transclude><scroll-paging spinner=vm.spinner show-message=\"!hideNoMoreMessage && vm.photos.length > 0\" hide-back-to-top=\"vm.totalPage < 2\" is-last-page=vm.isNoMorePhotoToLoad message=\"No more photos\"></scroll-paging><!-- <photo-swipe on-init=\"vm.onPhotoSwipeInit(photoSwipeInstance)\"></photo-swipe> --></div>");
$templateCache.put("app/components/photo-swipe/photo-swipe.html","<div class=photo-swipe ng-class=\"{\'photo-swipe--img-hover\': vm.isImgHovering}\"><div class=pswp tabindex=-1 role=dialog aria-hidden=true><!-- Background of PhotoSwipe. \r\n			 It\'s a separate element as animating opacity is faster than rgba(). --><div class=pswp__bg></div><!-- Slides wrapper with overflow:hidden. --><div class=pswp__scroll-wrap><!-- Container that holds slides. \r\n				PhotoSwipe keeps only 3 of them in the DOM to save memory.\r\n				Don\'t modify these 3 pswp__item elements, data is added later on. --><div class=pswp__container><div class=pswp__item></div><div class=pswp__item></div><div class=pswp__item></div></div><!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. --><div class=\"pswp__ui pswp__ui--hidden\"><div class=pswp__top-bar><!--  Controls are self-explanatory. Order can be changed. --><!-- <div class=\"pswp__counter\"></div> --> <button class=\"pswp__button pswp__button--close\" title=\"Close (Esc)\"><!-- <span class=\"photo-swipe__close-btn-label\">CLOSE</span> --></button><!-- <div ng-click=\"vm.close()\" class=\"photo-swipe__close-btn cusor--pointer\"><span class=\"photo-swipe__close-btn__text\">CLOSE</span> <span class=\"icon-close\"></span></div> --><!-- <div ng-click=\"vm.closePopup()\" class=\"popup-close-btn cusor--pointer\"><span class=\"popup-close-btn__text\">CLOSE</span> <span class=\"icon-close\"></span></div> --><!-- <button class=\"pswp__button pswp__button--share\" title=\"Share\"></button> --><!-- <button class=\"pswp__button pswp__button--fs\" title=\"Toggle fullscreen\"></button> --><!-- <button class=\"pswp__button pswp__button--zoom\" title=\"Zoom in/out\"></button> --><!-- Preloader demo http://codepen.io/dimsemenov/pen/yyBWoR --><!-- element will get class pswp__preloader--active when preloader is running --><div class=pswp__preloader><div class=pswp__preloader__icn><div class=pswp__preloader__cut><div class=pswp__preloader__donut></div></div></div></div></div><button class=\"pswp__button pswp__button--arrow--left\" title=\"Previous (arrow left)\"><i class=icon-arrow_left></i></button> <button class=\"pswp__button pswp__button--arrow--right\" title=\"Next (arrow right)\"><i class=icon-arrow_right></i></button><div class=pswp__caption><div class=pswp__caption__center></div></div><div class=photo-swipe__footer><div class=photo-swipe__footer__title>{{vm.currentPhoto.title}}</div><div class=photo-swipe__footer__description>{{vm.currentPhoto.description}}</div><vote-btn photo=vm.currentPhoto></vote-btn></div></div></div></div></div>");
$templateCache.put("app/components/progress-circle/progress-circle.html","<div class=\"overlay progress-circle\"><div class=\"overlay overlay--black\"></div><div data-pct=100 class=\"progress-circle__progress-container progress-circle--success\"><svg id=svg width=200 height=200 viewPort=\"0 0 100 100\" version=1.1 xmlns=http://www.w3.org/2000/svg><circle r=90 cx=100 cy=100 fill=transparent stroke-dasharray=565.48 stroke-dashoffset=0></circle><circle id=bar r=90 cx=100 cy=100 fill=transparent stroke-dasharray=565.48 stroke-dashoffset=0></circle></svg></div></div>");
$templateCache.put("app/components/pixerf-photo-swipe/pixerf-photo-swipe.html","<div class=pixerf-photo-swipe ng-class=\"{\'photo-swipe--img-hover\': vm.isImgHovering}\"><div class=\"owl-carousel owl-theme\"></div><div class=pixerf-photo-swipe__footer><div ng-if=vm.currentPhoto.prize class=\"pixerf-photo-swipe__footer__prize text--theme\" ng-bind-html=vm.currentPhoto.prize></div><div ng-if=vm.currentPhoto.prize class=pixerf-photo-swipe__footer__author>{{vm.currentPhoto.name}}</div><div class=pixerf-photo-swipe__footer__title>{{vm.currentPhoto.title}}</div><div class=pixerf-photo-swipe__footer__description><hm-read-more hm-text={{vm.currentPhoto.description}} hm-limit=150 hm-more-text=\"See more\" hm-less-text=\"See less\" hm-dots-class=dots hm-link-class=pixerf-photo-swipe__footer__description__toogle-link></hm-read-more></div><vote-btn ng-if=!options.isDisableVote photo=vm.currentPhoto></vote-btn></div></div>");
$templateCache.put("app/components/scroll-paging/scroll-paging.html","<div class=scroll-paging ng-class=\"{\'scroll-paging--loading\': spinner.isVisible}\"><spinner-win ng-if=spinner.isVisible spinner=spinner></spinner-win><!--<spinner spinner=\"spinner\"></spinner>--><div ng-if=\"isLastPage && showMessage && !spinner.isVisible\" class=\"scroll-paging__last-page-message text-center\"><span>{{message}}</span> <a ng-show=!hideBackToTop class=\"text--color-pixerf-theme text--bold\" ng-click=vm.scrollToTop()>Back to top</a></div></div>");
$templateCache.put("app/components/spinner-win/spinner-win.html","<div class=spinner-win ng-show=spinner.isVisible ng-class=\"{\'spinner-win--isOverlay-mode absolute absolute--full\': isOverlayMode}\"><div class=bg_preloader><div class=\"preloader one\"></div><div class=\"preloader two\"></div><div class=\"preloader three\"></div></div></div>");
$templateCache.put("app/components/vote-btn/vote-btn.html","<div class=vote-btn ng-class=\"{\'vote-btn--voted\':photo.is_voted,\'vote-btn--show-confirmation && !photo.is_voted\': vm.isConfirming, \'vote-btn--hide-confirmation\': !vm.isConfirming || photo.is_voted}\"><div class=vote-btn__inner-wrapper ng-if=vm.isVotable.data><div class=vote-btn__vote-btn-wrapper><button class=vote-btn__vote ng-disabled=\"vm.isWorking || !vm.isVotable.data\" ng-click=\"$event.stopPropagation(); vm.onVoteBtnClicked(photo)\">{{photo.is_voted ? \'Voted\' : \'Vote\'}}</button></div><div class=vote-btn__vote-confirmation><h4>Vote for this photo?</h4><div class=vote-btn__vote-confirmation__btns><button class=vote-btn__vote-confirmation__btn-ok ng-click=$event.stopPropagation();vm.onConfirmBtnClicked(vm.CHOICES.CONFIRM)>Yes</button> <button class=vote-btn__vote-confirmation__btn-cancel ng-click=$event.stopPropagation();vm.onConfirmBtnClicked(vm.CHOICES.CANCEL)>Cancel</button></div></div></div></div>");
$templateCache.put("app/components/winners-list/winners-list.html","<div class=\"winners-list disable-owl-swipe owl-carousel owl-theme\"><div class=\"winners-list__photo winners-list__photo--runner-up-1st\"><div class=winners-list__photo__inner-wrapper><h4 class=\"winners-list__photo__title text--theme\" ng-bind-html=vm.photos.data[1].prize></h4><h4 class=\"text--white winners-list__photo__author\">{{vm.photos.data[1].name}}</h4><div class=image-wrapper><img class=cusor--zoom ng-src={{vm.photos.data[1].urlSmall}} image-load><div class=\"image-overlay vertical-align-middle\"><div class=\"overlay overlay--black\"></div><i ng-click=\"$event.stopPropagation(); vm.onPhotoClicked(vm.photos.data[1])\" class=icon-zoom-in title=\"View in bigger size\"></i></div></div></div></div><div class=\"winners-list__photo winners-list__photo--winner\"><div class=winners-list__photo__inner-wrapper><h4 class=\"winners-list__photo__title text--theme\" ng-bind-html=vm.photos.data[0].prize></h4><h4 class=\"text--white winners-list__photo__author\">{{vm.photos.data[0].name}}</h4><div class=image-wrapper><img class=cusor--zoom ng-src={{vm.photos.data[0].urlSmall}} image-load><div class=\"image-overlay vertical-align-middle\"><div class=\"overlay overlay--black\"></div><i ng-click=$event.stopPropagation();vm.onPhotoClicked(vm.photos.data[0]) class=icon-zoom-in title=\"View in bigger size\"></i></div></div></div></div><div class=\"winners-list__photo winners-list__photo--runner-up-2nd\"><div class=winners-list__photo__inner-wrapper><h4 class=\"winners-list__photo__title text--theme\" ng-bind-html=vm.photos.data[2].prize></h4><h4 class=\"text--white winners-list__photo__author\">{{vm.photos.data[2].name}}</h4><div class=image-wrapper><img class=cusor--zoom ng-src={{vm.photos.data[2].urlSmall}} image-load><div class=\"image-overlay vertical-align-middle\"><div class=\"overlay overlay--black\"></div><i ng-click=$event.stopPropagation();vm.onPhotoClicked(vm.photos.data[2]) class=icon-zoom-in title=\"View in bigger size\"></i></div></div></div></div></div>");
$templateCache.put("app/components/videos-popup/videos-popup.html","<div><div class=popup-videos__video-wrapper ng-repeat=\"video in videos\"><div class=\"popup-videos__video cusor--pointer\" ng-click=vm.onVideoClicked(video) title=Play><div class=\"popup-videos__video__thumbnail relative\" ng-style=\"{\'background-image\':\'url({{video.poster}})\'}\"><div class=overlay></div><div class=\"popup-videos__video__play-icon icon-play vertical-align-middle\"></div></div><div class=popup-videos__video__title>{{video.title}}</div></div></div></div>");}]);